import { DecimalPipe } from '@angular/common';
import { ChangeDetectionStrategy, ChangeDetectorRef, Component, HostListener, Input, OnInit, ViewChild, ElementRef } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { NavigationExtras, Router } from '@angular/router';
import { ChartSelectionCard } from '../Interfaces/chart-selection-card';
import { UserSelectionsService } from '../Services/user-selections.service';
import { animate, keyframes, style, transition, trigger } from '@angular/animations';
import { CommonChartmoduleService } from '../Services/common-chartmodule.service';
import { LoaderService } from 'src/app/common/services/loader.service';
import { SnapshotService } from '../Services/snapshot.service';
import { LandingConstants } from '../Constant/landing-constants';
import { SnapshotSharedVariablesService } from '../Services/snapshot-shared-variables.service';
import { CustomsnapshotService } from '../Services/customsnapshot.service';
import * as _ from 'lodash';
import { LandingCardInterface } from '../Interfaces/landing-card';
import { AlertMessageModel } from 'src/app/common/models/common.model';
import { AlertMessageService } from 'src/app/common/services/alert-message.service';
import { UploadService } from 'src/app/common/services/upload.service';


@Component({
  selector: 'app-chart-select-widget-library',
  templateUrl: './chart-select-widget-library.component.html',
  styleUrls: ['./chart-select-widget-library.component.scss'],
  animations: [
    trigger('rotate', [
      transition(':increment', [
        animate('80ms', keyframes([
          style({ transform: 'translateX(50%)', opacity: 0 }),
          style({ transform: 'translateX(0)', opacity: 1 }),
        ])),
      ]),
      transition(':decrement', [
        animate('80ms', keyframes([
          style({ transform: 'translateX(-50%)', opacity: 0 }),
          style({ transform: 'translateX(0)', opacity: 1 }),
        ])),
      ]),
    ]),
  ],
  changeDetection: ChangeDetectionStrategy.OnPush
})

export class ChartSelectWidgetLibraryComponent implements OnInit {
  @ViewChild('sectionInput') sectionInputRef!: ElementRef<HTMLInputElement>;
  sectionInputFocused: boolean = false; // show clear icon only while focused
  @Input() selectedSnapshotData: any | undefined;
  @Input() clientStudyData: any | undefined;
  availableChartForSelection: ChartSelectionCard[] = [];
  chartDisplayName: string = "";
  //  baseUrl: string = environment.baseUrl;
  centerIndex = 1; // Initial center index
  bucketsToShow: any[] = [];
  currentBucketId: number | null = null;
  selectedBucketId: number | null = null;
  isDeleteSubsection: boolean = false;
  //showImageTiles:boolean = true;
  chartId: any = 1;
  carouselView: boolean = false;
  chunkedCharts: any[][] = [];
  titleName: string = "Grid View";
  ifCountMatched: boolean = false;
  countofWidgets = 0;
  showDeletePopup: boolean = false;
  availableCharts = LandingConstants.availableCharts;
  snapshotTypeData: any[] = [];
  snapshotTypeitem: any = [];
  selectedSnapshotType: any;
  customProperties: any;
  show: boolean = false;
  gotData: boolean = false;
  deletemessage: any = "";
  customMetrics: any;
  showErrorPopUp = false;
  popUpMessage = '';
  errorheaderTitle = '';

  metricdata: any;
  metricGroupLength: any;

  typeHeader = 'Snapshot Types';
  snapshotTypes: any[] = [];
  isDeleteSection: boolean = false;
  audienceCohortType: string = '';
  metricgroup: any;
  metrics: any;
  uniqueMetricsWithTrend: any;
  groupedData1: any;
  groupedData: any = [];
  prevWidgetList = [];
  separateFomExists: boolean = false;

  constructor(private _loaderService: LoaderService, private _configData: SnapshotService, private cdRef: ChangeDetectorRef, private clientDetails: SnapshotSharedVariablesService, private userSelectionServiceObj: UserSelectionsService, private routerObj: Router, private titleService: Title, private decimalPipe: DecimalPipe, private commonChartModule: CommonChartmoduleService, private _configService: SnapshotService, private _configCustomService: CustomsnapshotService, private cdr: ChangeDetectorRef, private _alertService: AlertMessageService, private uploadService: UploadService) {
    let data1 = {
      client_code: this.clientDetails.clientDetails.client_name,
      study_name: this.clientDetails.clientDetails.selectedStudy,
    };
    let clientdata = {
      "clientName": this._configData.clientName,
      "snapshotName": this.clientDetails.clientDetails.selectedStudy,
    }

    this._configCustomService.getCustomSnapshotProperties().subscribe((r: any) => {
      this._configCustomService.widgets = JSON.parse(r?.Data)?.ChartPropertiesOptionSelection.map((obj: any) => {
        return {
          SnapshotType: obj.SnapshotType,
          Chart: obj.Chart,
          ChartGroup: obj.ChartGroup,
          cohortType:obj.cohortType
        };
      });
      this._configCustomService.widgets.push({
        Chart: "LINE CHART",
        ChartGroup: "Line Chart",
        SnapshotType: "Single Brand"
      });
      this.widgets = this._configCustomService.widgets;
      this.updateChartSelections();
      this._configCustomService.prepareCustomizationList(JSON.parse(r?.Data));

      if (!this.isShowLoader) {
        this._loaderService.showLoader();
        this.isShowLoader = true;
      }
      
      this._configData.getWidgetLibraryMetricList(data1)
        .subscribe((data: any) => {
          this._configCustomService.getCustomMetrics(clientdata).subscribe((res: any) => {
            this._configCustomService.prepareCustomizationList(JSON.parse(r?.Data));
            this.metricdata = JSON.parse(data.Data);
            this.metricdata = this.metricdata.filter((item: any) => item['Is_snapshot'] === 1);
            this.metricGroupLength = this.metricdata.filter((a: any) => a.WidgetMapping_VariableGroups != "").length;
            if (this.metricGroupLength != 0) {
              this.metricgroup = Array.from(
                new Set(
                  this.metricdata.map(
                    (item: any) => item['WidgetMapping_VariableGroups']
                  )
                )
              );
            }

            this.metrics = Array.from(
              new Set(
                this.metricdata.map(
                  (item: any) => item['WidgetMapping_Variables']
                )
              )
            );
            this.uniqueMetricsWithTrend = Array.from(
              new Map(
                this.metricdata.map((item: any) => [
                  `${item.WidgetMapping_Variables}-${item.Trend_Flag}`,
                  { WidgetMapping_Variables: item.WidgetMapping_Variables, Trend_Flag: item.Trend_Flag }
                ])
              ).values()
            );
            let brandanalysis: any = {};
            this.metrics.forEach((m: any) => {
              const foundItem = this.metricdata.find((m1: any) => m1['WidgetMapping_Variables'] === m);
              if (foundItem) {
                const isBrandAnalysisValue = foundItem['is_brandanalysis'];
                brandanalysis[m] = isBrandAnalysisValue;
                // Or store the result in another array or object as needed
              }
            });
            this.metrics = this.metrics.map((m: any) => ({
              option: m,
              isSelected: false,
              selectorder: 0,
              isBrandAnalysis: brandanalysis[m]
            }));
            this.groupedData1 = this.getGroupedData(this.metricdata);
            this.groupedData1.forEach((item: any) => {
              item.option = item.metricgroup;
              item.Level2 = item.metrics.map((m: any) => ({
                option: m,
                isSelected: false,
                selectorder: 0,
              }));
              item.type = 'checkbox';
              item.isDropdownOpen = false;
            });

            // this.groupedData = [{
            //   option: "METRIC GROUP",
            //   isDropdownOpen: false,
            //   type: "radio",
            //   Level2: this.metricgroup?.map((m: any) => ({
            //     option: m,
            //     isSelected: false,
            //     selectorder: 0
            //   }))
            // },
            // {
            //   option: "METRICS",
            //   isDropdownOpen: false,
            //   type: "checkbox",
            //   Level2: this.metrics
            // }
            // ]
            if (this.metricgroup && this.metricgroup.length > 0) {
              this.groupedData.push({
                option: "METRIC GROUP",
                isDropdownOpen: false,
                type: "radio",
                Level2: this.metricgroup?.map((m: any) => ({
                  option: m,
                  isSelected: false,
                  selectorder: 0,
                  metrics: (this.groupedData1.find((g: any) => g.metricgroup === m)?.metrics || [])
                }))
              })
            }
            if (this.metrics && this.metrics.length > 0) {
              this.groupedData.push({
                option: "METRICS",
                isDropdownOpen: false,
                type: "checkbox",
                Level2: this.metrics
              })
            }
            this._configCustomService.metricData = this.groupedData;
            // this._configCustomService.prepareCustomizationList(JSON.parse(r?.Data));
            this.isMetricConfigured = true;



            if (res.Data != "" && res.Data != null) {
              this.customMetrics = JSON.parse(res?.Data);
              this._configCustomService.widgetAllCustomMetrics = this.customMetrics;
              if (this.customMetrics != null && this.customMetrics != undefined && this.customMetrics.length > 0) {
                this.customMetrics = this.customMetrics.filter((m: any) => m.soft_delete == "0");
              }
              this._configCustomService.widgetCustomMetrics = this.customMetrics
              // let metrics1 = Array.from(
              //   new Set(
              //     this.customMetrics.map(
              //       (item: any) => item['selection_name']
              //     )
              //   )
              // );
      let metrics = Array.from(
  new Map(
    this.customMetrics.map((item: any) => [
      item.selection_name,
      {
        selection_name: item.selection_name,
        extensionOptions: item.extensionOptions || []
      }
    ])
  ).values()
);


              this.groupedData.push({
                option: "CUSTOM METRICS",
                isDropdownOpen: false,
                type: "checkbox",
                Level2: metrics.map((m: any) => ({
                  option: m.selection_name,
                  isSelected: false,
                  selectorder: 0,
                  isBrandAnalysis: "",
                  extensionOptions: m.extensionOptions || []
                }))
              })

              this._configCustomService.metricData = this.groupedData;
              this._configCustomService.prepareCustomizationList(JSON.parse(r?.Data));
              this.cdRef.detectChanges();
              //this.existingData = JSON.parse(r?.Data);
              //this.existing_custom_metric = [];
              //this.existing_custom_metric_details = [];
              //this.setCustomMetricList();
              //this.checkIfMetricInFomPresent();
              //this.cdRef.detectChanges();
            }
            else {
              this._configCustomService.prepareCustomizationList(JSON.parse(r?.Data));
              this.cdRef.detectChanges();

            }
            this._loaderService.hideLoader();
            this.isShowLoader = false;
          });
        },
          (error: any) => {
            // Handle error here
            // this.showErrorPopUp=false;
            this._loaderService.hideLoader();
            this.isShowLoader = false;
            this.isMetricConfigured = false
            setTimeout(() => {
              this.showErrorPopUp = true;
              this.errorheaderTitle = "Alert";
              this.popUpMessage = "Metrics not Configured for the Study :" + this.clientDetails.clientDetails.selectedStudy;
              this.cdRef.detectChanges();
            }, 0)
          }

        );
    })

  }
  @ViewChild('fomFileInput') fomFileInput!: ElementRef<HTMLInputElement>;
  downloadDropdownOpen: boolean = false;
  toggleDownloadDropdown(event: Event) {
    event.stopPropagation();
    if (this.widgetList.length == 0) return;
    this.downloadDropdownOpen = !this.downloadDropdownOpen;
  }

  downloadMasterFOM(event?: Event) {
    if (event) event.stopPropagation();
    const client = this.clientDetails.clientDetails.client_name;
    const study = this.clientDetails.clientDetails.selectedStudy;
    this._loaderService.showLoader();
    this.uploadService.downloadSnapshotMasterFOM(client, study).subscribe(
      (blob: Blob) => {
        const fileName = `Snapshot_Master_FOM_${client}_${study}_${this.getCurrentDateTime()}.xlsx`;
        this.downloadBlob(blob, fileName);
        this._loaderService.hideLoader();
        this.downloadDropdownOpen = false;
      },
      (error) => {
        this._loaderService.hideLoader();
        this.showMessagePopup('Something went wrong while downloading Master FOM', 'Alert');
        this.downloadDropdownOpen = false;
      }
    );
  }

  downloadLatestFOM(event?: Event) {
    if (event) event.stopPropagation();
    const client_name = this.clientDetails.clientDetails.client_name;
    const study = this.clientDetails.clientDetails.selectedStudy;
    const snapshot_name = this.clientDetails.clientDetails.study;
    const snapshot_type = this._configCustomService.selectedSnapshotType?.name ?? this.selectedSnapshotType?.name ?? '';
    const section_name = this.selectedSection ?? '';
    const subsection_name = this.selectedSubSection ?? '';
    this._loaderService.showLoader();
    this.uploadService.downloadSnapshotLatestFOM(client_name, study, snapshot_name, snapshot_type, section_name, subsection_name).subscribe(
      (blob: Blob) => {
        const fileName = `Snapshot_Latest_FOM_${snapshot_name}_${snapshot_type}_${this.getCurrentDateTime()}.xlsx`;
        this.downloadBlob(blob, fileName);
        this._loaderService.hideLoader();
        this.downloadDropdownOpen = false;
      },
      (error) => {
        this._loaderService.hideLoader();
        this.showMessagePopup('Something went wrong while downloading Latest FOM', 'Alert');
        this.downloadDropdownOpen = false;
      }
    );
  }

  private downloadBlob(data: Blob, filename: string) {
    const blob = new Blob([data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = filename;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    window.URL.revokeObjectURL(url);
  }

  UploadFOMClicked() {
    if (this.widgetList.length == 0) return;
    this.fomFileInput?.nativeElement?.click();
  }

  onFomFilesSelected(event: any) {
    const input = event.target as HTMLInputElement;
    if (!input.files || input.files.length === 0) {
      return;
    }
    const file = input.files[0];

    const client_name = this.clientDetails.clientDetails.client_name;
    const study_name = this.clientDetails.clientDetails.selectedStudy;
    const snapshot_name = this.clientDetails.clientDetails.study;
    const snapshot_type = this._configCustomService.selectedSnapshotType?.name ?? this.selectedSnapshotType?.name ?? '';
    const section_name = this.selectedSection ?? '';
    const subsection_name = this.selectedSubSection ?? '';

    this._loaderService.showLoader();
    this.uploadService.uploadSeparateFOM(
      client_name,
      study_name,
      snapshot_name,
      snapshot_type,
      section_name,
      subsection_name,
      file
    ).subscribe(
      (response) => {
        this._loaderService.hideLoader();
        this.showMessagePopup('FOM uploaded successfully.', 'Success');
        // reset the input so selecting the same file again re-triggers change
        input.value = '';
        this.separateFomExists = true;
      },
      (error) => {
        this._loaderService.hideLoader();
        this.showMessagePopup('Something went wrong while uploading FOM.', 'Alert');
        input.value = '';
      }
    );
  }

  getCurrentDateTime() {
    const now = new Date();
    const year = now.getFullYear();
    const month = String(now.getMonth() + 1).padStart(2, '0');
    const day = String(now.getDate()).padStart(2, '0');
    const hours = String(now.getHours()).padStart(2, '0');
    const minutes = String(now.getMinutes()).padStart(2, '0');
    const seconds = String(now.getSeconds()).padStart(2, '0');
    return `${year}-${month}-${day}-${hours}-${minutes}-${seconds}`;
  }
  // ngOnChanges(changes: SimpleChanges): void {

  //  // throw new Error('Method not implemented.');
  // }
  widgets: any;
  widgetList: any = [];
  widgetDetailss: any;
  isShowLoader: boolean = false;
  isMetricConfigured: boolean = true;
  message: string = "If this metric was configured in any existing widget, please update the metric in the Widget Library. Affected widgets will be highlighted in Red Border for easy identification."
  ngOnInit() {
    //Making preview disable initially 
    this.showPreview = false;
    const previewbtn = document.querySelector('.preview-button');
    if (previewbtn) previewbtn.classList.add('disabled');

    this.widgets = this._configCustomService.widgets;
    this.audienceCohortType = this._configService.audienceCohortType;
    const dropdownContainer = document.querySelector('.dropdown-container') as HTMLElement;
    if (dropdownContainer) {
      dropdownContainer.style.display = 'none';
    }
    if (!this.isShowLoader) {
      this._loaderService.showLoader();
      this.isShowLoader = true;
    }
    this.initialCall();
    if (this._configCustomService.backFromPreview == 1) { //on preview back click making preview button enabled
      this.showPreview = true;
      // this._configCustomService.backFromPreview=0;
    }
    if (this._configCustomService.disablePreviewOnCustomizationSave == 1) { //on preview back click making preview button enabled
      this.showPreview = false;
      const previewbtn = document.querySelector('.preview-button');
      if (previewbtn) previewbtn.classList.add('disabled');
      // this._configCustomService.backFromPreview=0;
    }
    if (this._configService.objectFromSnapshotLayout != '') {
      this.showPreview = true;
      // this._configCustomService.backFromPreview=0;
    }
    // if(this._configCustomService?.recievedStatusDataOnBackButtonClick?.fromBack){
    //   this.showPreview = this._configCustomService.showPreviewStatus;
    // }
    if (this._configCustomService.widgetSaveObjectCustom.length > 0)
      this.widgetList = this._configCustomService.getVisualSelectWidgetDetails(this._configCustomService.widgetSaveObjectCustom[0], this._configCustomService.selectedSection, (this._configCustomService.selectedSubsection == undefined || this._configCustomService.selectedSubsection == "") ? "NA" : this._configCustomService.selectedSubsection, this._configCustomService.selectedSnapshotType?.name,  this._configService.audienceCohortType)
    // setTimeout(() => {
    // this._loaderService.hideLoader();
    // }, 10000)
  }

  initialCall() {
    // this._loaderService.hideLoader();
    this.GetThisSnapshotData();

  }

  showMessagePopup(message: string = "Are you show", headerTxt: string = "Information"): void {
    const alertObj: AlertMessageModel = {
      header: headerTxt,
      message: message,
      show: true,
    };
    this._alertService.showAlert(alertObj);
  }

  getGroupedData(
    data: {
      WidgetMapping_Variables: string;
      WidgetMapping_VariableGroups: string;
    }[]
  ): { metricgroup: string; metrics: string[] }[] {
    const groups: { [key: string]: Set<string> } = {};

    data.forEach((item) => {
      if (!groups[item.WidgetMapping_VariableGroups]) {
        groups[item.WidgetMapping_VariableGroups] = new Set();
      }
      groups[item.WidgetMapping_VariableGroups].add(
        item.WidgetMapping_Variables
      );
    });

    const result: { metricgroup: string; metrics: string[] }[] = [];

    for (const group in groups) {
      if (groups.hasOwnProperty(group)) {
        result.push({
          metricgroup: group,
          metrics: Array.from(groups[group]),
        });
      }
    }

    return result;
  }

  getUniqueSectionList() {
    let uniquesectionnames: any = [];
    let data = this._configCustomService.widgetSaveObjectCustom[0];
    // if (data.client_name === this.clientDetails.clientDetails.client_name && data.snapshot_name === this.clientDetails.clientDetails.study) {
    //   // Loop through snapshotType array
    //   for (const snapshot of data.snapshotType) {
    //     if (snapshot.snapshotType_name === this.selectedSnapshotType?.name) {
    //       // Extract section names
    //       snapshot.section.forEach((section: any) => {
    //         const sectionObj = { 
    //           value: section.section_name ,
    //           selected:false,
    //           name: section.section_name
    //         };

    //         // Check if the section_name is already in the result array
    //         if (!uniquesectionnames.some((obj:any) => obj.section_name === sectionObj.name)) {
    //           uniquesectionnames.push(sectionObj); // Add unique section_name to result array
    //         }
    //       });
    //     }
    //   }
    // }
    if (data) {
      if (data.client_name === this.clientDetails.clientDetails.client_name && data.snapshot_name === this.clientDetails.clientDetails.study) {
        // Loop through snapshotType array
        data.snapshotType.forEach((snapshot: any) => {
          const snapshotObj = { snapshotType_name: snapshot.snapshotType_name, sections: [] as Array<{ section_name: string }> };

          // Loop through all sections in the snapshotType
          snapshot.section.forEach((section: any) => {
            const sectionObj: any = {
              name: section.section_name,
              value: section.section_name,
              selected: false
            };

            // Check if the section_name is already in the sections array
            if (!snapshotObj.sections.some((obj) => obj.section_name === sectionObj.name)) {
              snapshotObj.sections.push(sectionObj); // Add unique section_name to the sections array
            }
          });

          // Push the snapshotObj with unique sections
          uniquesectionnames.push(snapshotObj);
        });
      }
    }

    if (uniquesectionnames.length > 0) {
      let sectionDetails = uniquesectionnames.find((uq: any) => uq.snapshotType_name == this._configCustomService.selectedSnapshotType?.name);
      if (sectionDetails) {
        this.sectionList = sectionDetails.sections;
        this._configCustomService.sectionList = this.sectionList;
      }
      else {
        this.sectionList = [];
        this._configCustomService.sectionList = [];
      }
    }
    else {
      this.sectionList = [];
      this._configCustomService.sectionList = [];
    }
  }

  getUniqueSubsectionList() {
    let uniquesubsectionnames: any = [];
    let data = this._configCustomService.widgetSaveObjectCustom[0];
    if (data) {
      if (data.client_name === this.clientDetails.clientDetails.client_name && data.snapshot_name === this.clientDetails.clientDetails.study) {
        // Loop through snapshotType array
        for (const snapshot of data.snapshotType) {
          if (snapshot.snapshotType_name === this.selectedSnapshotType?.name) {
            // Loop through all sections
            snapshot.section.forEach((section: any) => {
              const sectionObj = { section_name: section.section_name, subsections: [] as Array<{ subsection_name: string }> };

              // Loop through all subsections in the section
              section.subsection.forEach((subsection: any) => {
                const subsectionObj: any = {
                  value: subsection.subsection_name,
                  name: subsection.subsection_name,
                  selected: false
                };
                // Check if the subsection_name is already in the subsection array
                if (!sectionObj.subsections.some((obj) => obj.subsection_name === subsectionObj.name)) {
                  sectionObj.subsections.push(subsectionObj); // Add unique subsection_name to the subsections array
                }
              });
              // Push the sectionObj with unique subsections if it's not already added
              uniquesubsectionnames.push(sectionObj);
            });
          }
        }
      }
    }

    if (uniquesubsectionnames.length > 0) {
      let subsectionlist = uniquesubsectionnames.find((uq: any) => uq.section_name == this.selectedSection);
      if (subsectionlist) {
        subsectionlist.subsections = subsectionlist.subsections.filter((ss: any) => ss.name != "NA")
        this.subsectionList = subsectionlist.subsections;
      }
      else {
        this.subsectionList = [];
      }
    }

    if ((this._configCustomService.selectedSubsection != undefined && this._configCustomService.selectedSubsection != "") && this._configCustomService.recievedStatusDataOnBackButtonClick?.fromBack && !this.isDeleteSubsection) {
      const itemExists = this.subsectionList.some(
        (item: any) => item.name === this._configCustomService.selectedSubsection
      );
      // Only push if the item doesn't already exist
      if (!itemExists) {
        this.subsectionList.push({
          name: this._configCustomService.selectedSubsection,
          value: this._configCustomService.selectedSubsection,
          selected: true
        });
      }
    }

  }

  SetAlreadyExistingSnapshotTypesandSection() {
    let snapshotType = this.snapshotTypes.find((st: any) => st.name == this._configCustomService.selectedSnapshotType.name);
    let section = this._configCustomService.selectedSection;
    let subsection = this._configCustomService.selectedSubsection;
    if (snapshotType) {
      this.onTypeClick(snapshotType);
      this.typeHeader = snapshotType.name;
      this.cdRef.detectChanges();
    }
    if (section != "") {
      let s = this.sectionList.find((s: any) => s.name == section);
      if (s) {
        this.onSectionDropdownClick(s);
      }
      this.selectedSection = section;
      this._configCustomService.selectedSection = section;
      const subsectionBlock = document.querySelector('.widget-items.subsection-block');
      if (this.selectedSection != "" || undefined) {

        if (subsectionBlock) {
          subsectionBlock.classList.remove('disabled');
        }
      }
      else {
        if (subsectionBlock) {
          this.subSectionDropdownPopup = false;
          subsectionBlock.classList.add('disabled');
        }
      }
      const chartSelectionContainer = document.querySelector('.chart-selection-container');
      if (chartSelectionContainer && this.selectedSection != '') {
        chartSelectionContainer.classList.remove('disabled');
        this._configCustomService.isAdditionalConfig = true;
      }
      else {
        chartSelectionContainer?.classList.add('disabled');
        this._configCustomService.isAdditionalConfig = false;
        this.selectedSubSection = "";
        this.subsectionList.forEach((ss: any) => { ss.selected = false })
      }
      this.cdRef.detectChanges();
    }
    if (subsection) {
      let s = this.subsectionList.find((s: any) => s.name == subsection);
      if (s) {
        this.onSubSectionChange(s);
      }
      this.selectedSubSection = subsection;
      this.subSectionHeader = subsection;
      this._configCustomService.selectedSubsection = subsection;
      this.cdRef.detectChanges();
    }
    this.updateChartSelectedNumber();
    if (this._configCustomService.widgetSaveObjectCustom.length > 0)
      this.widgetList = this._configCustomService.getVisualSelectWidgetDetails(this._configCustomService.widgetSaveObjectCustom[0], this._configCustomService.selectedSection, (this._configCustomService.selectedSubsection == undefined || this._configCustomService.selectedSubsection == "") ? "NA" : this._configCustomService.selectedSubsection, this._configCustomService.selectedSnapshotType?.name,  this._configService.audienceCohortType)
    if (this.widgetList.length == 0) {
      this.showPreview = false;
      const previewbtn = document.querySelector('.preview-button');
      if (previewbtn) previewbtn.classList.add('disabled');
    }
    this.cdRef.detectChanges();
    // this._loaderService.hideLoader();

  }



  enableWidgetsOnStudy() {
    let i: any[] = [];
    this.commonChartModule.defaultSelectedSnapshotType = this.selectedSnapshotType;
    //this.customProperties
    // setTimeout(() => {
    //   this.customProperties?.forEach((item: any) => {
    //     if (item.SnapshotType.trim() == this.selectedSnapshotType.name) {
    //       i.push(item)
    //     }
    //   });
    //   if (i.length > 0) {
    //     this.commonChartModule.updateWidgets(i);
    //   } else {
    //     const chartContainer = document.querySelector('.available-charts-tiles');
    //     if (chartContainer) {
    //       chartContainer.innerHTML = 'No Charts Available';
    //     }
    //   }
    // }, 200)


    // this.commonChartModule.widgetsForSelectedSnapType=i;



    let chartGroups = [...new Set(i.map(item => item.ChartGroup))];
    chartGroups = chartGroups.map(item => item.trim().replace(/\s+/g, '').toLowerCase());

    // this.availableCharts = LandingConstants.availableCharts;
    // this.availableCharts.forEach((chart: any) => { chart.isAvailable = true; });
    // this.availableCharts.forEach((chart: any) => {
    //   if (!chartGroups.includes(chart.displayName.trim().replace(/\s+/g, '').toLowerCase())) {
    //     chart.isAvailable = false;
    //   }
    // });

    //this.widgetDetails = JSON.parse(localStorage.getItem('TotalwidgetDetailss') || "");

    // this.widgetDetails = this._configService.WidgetLibSaveDataObject;
    if (this.widgetDetails != null && this.widgetDetails != undefined && this.widgetDetails.length > 0)
      this.widgetDetails = this.widgetDetails.filter((m: any) => m.snapshot_type == this._configCustomService.selectedSnapshotType.name);

    if (this.widgetDetails != null && this.widgetDetails != undefined) {
      this.availableCharts.forEach((chart: any) => {
        let count = 0;
        if (this.widgetDetails?.WidgetDetail != undefined)
          count = this.widgetDetails?.WidgetDetail.filter((m: any) => chart.displayName.trim().replace(/\s+/g, '').toLowerCase() === m.widgetparentchartType.trim().replace(/\s+/g, '').toLowerCase()).length;
        else if (this.widgetDetails?.WidgetDetail != undefined)
          count = this.widgetDetails?.WidgetDetail.filter((m: any) => chart.displayName.trim().replace(/\s+/g, '').toLowerCase() === m.widgetparentchartType.trim().replace(/\s+/g, '').toLowerCase()).length;
        chart.chartSelectedNumber = count > 0 ? count : 0;

      });

      this.cdr.detectChanges();
    }

    // this._loaderService.hideLoader();
  }

  // async getCustomProperties(): Promise<void> {
  //   this._configService.getCustomProperties().subscribe(
  //     (response) => {
  //       this.customProperties = JSON.parse(response.Data); // Assign the retrieved data to the variable
  //        // Log the data
  //       // You can perform further operations with this.customProperties here
  //     },
  //     (error) => {
  //       //console.error('Error occurred while fetching custom properties:', error);
  //     }
  //   );
  //   return new Promise(resolve => {
  //     // Perform asynchronous operation
  //     setTimeout(() => {
  //       resolve();
  //     }, 2000);
  //   });
  // }



  //   this._loaderService.showLoader()
  //   // Set the selected snapshot name
  //   this._configService.snapshotSelectedName = this.clientDetails.clientDetails.study;

  //   try {
  //     // Fetch the client study data and ensure it's awaited
  //     const response = await firstValueFrom(
  //       this._configService.getClientStudyData({
  //         client_code: this.clientDetails.clientDetails.client_name,
  //         snapshot_name: this.clientDetails.clientDetails.study,
  //       })
  //     );

  //     // Await any custom property fetching (ensure this completes first)
  //     await this.getCustomProperties();

  //     // Check if the response contains valid data
  //     const data = response?.body?.Data;

  //     if (!data) {
  //       //console.error('No valid data received or the data is empty.');
  //       return;
  //     }

  //     // Parse the data and proceed only after it's fully parsed and confirmed
  //     const snapshotDetails = JSON.parse(data).snapshotType_details;

  //     // Handle "back" button behavior only after data is processed
  //     if (this._configCustomService.isBack && !this._configCustomService.recievedStatusDataOnBackButtonClick?.fromBack) {
  //       this._configCustomService.recievedStatusDataOnBackButtonClick.fromBack = this._configCustomService.isBack;
  //     }

  //     // Set the selected snapshot type only after fetching and parsing data
  //     this._configService.snapshotTypeSelectedName =
  //       this._configService.snapshotTypeSelectedName || snapshotDetails[0].snapshot_type;

  //     // Populate snapshot types after data is fully ready
  //     this.snapshotTypes = snapshotDetails.map((item: any) => {
  //       item.checked = item.snapshot_type === this._configService.snapshotTypeSelectedName;
  //       return {
  //         name: item.snapshot_type,
  //         value: item.snapshot_type,
  //         selected: false,
  //       };
  //     });

  //     // Assign data and ensure it's fully processed
  //     this.snapshotTypeData = snapshotDetails;
  //     this.show = true;

  //     // Check if there's a need to set existing snapshot types and sections when returning via back button
  //     if (
  //       this._configCustomService.selectedSnapshotType &&
  //       this._configCustomService.recievedStatusDataOnBackButtonClick?.fromBack
  //     ) {
  //       // this._loaderService.showLoader();
  //       this._configCustomService.isBack = this._configCustomService.recievedStatusDataOnBackButtonClick.fromBack;
  //       this._configCustomService.recievedStatusDataOnBackButtonClick.fromBack = false;
  //       this.SetAlreadyExistingSnapshotTypesandSection();
  //     }

  //     // Handle snapshot type data fetching after validation
  //     if (this.selectedSnapshotType) {
  //       await this.GetThisSnapshotTypeData(); // Ensure this operation is awaited too
  //       this.toggleChartSelectionContainer(false);
  //       // Enable the container after fetching
  //     } else {
  //       this.toggleChartSelectionContainer(true); // Disable container if no type is selected
  //       // this._loaderService.hideLoader(); // Hide loader only after everything is processed
  //     }

  //     // Detect changes once all operations are complete
  //     this.cdr.detectChanges();

  //   } catch (error) {
  //     // Error handling after trying to fetch data
  //     //console.error('Error fetching client study data:', error);
  //   }
  // };

  GetThisSnapshotData = () => {
    try {
      // Set the selected snapshot name
      this._configService.snapshotSelectedName = this.clientDetails.clientDetails.study;

      // Check if we have data passed from parent component
      if (this.clientStudyData && this.clientStudyData.body && this.clientStudyData.body.Data) {
        // Use the data passed from parent instead of making API call
        const data = this.clientStudyData.body.Data;
        this._configCustomService.client = this.clientDetails.clientDetails.client_name;
        this._configCustomService.snapshot = this.clientDetails.clientDetails.study;
        this.processSnapshotData(data);
      } else {
        // Fallback to API call if no data is passed
        this._configService.getClientStudyData({
          client_code: this.clientDetails.clientDetails.client_name,
          snapshot_name: this.clientDetails.clientDetails.study,
        }).subscribe(
          (response: any) => {
            const data = response?.body?.Data;
            if (!data) {
              //console.error('No valid data received or the data is empty.');
              return;
            }
            this._configCustomService.client = this.clientDetails.clientDetails.client_name;
            this._configCustomService.snapshot = this.clientDetails.clientDetails.study;
            this.processSnapshotData(data);
          },
          (error) => {
            console.error('Error:', error);
          }
        );
      }
    } catch (error) {
      //console.error('Error fetching client study data:', error);
    }
  };

  private processSnapshotData(data: string) {
    // Parse the data
    let snapshotDetails = JSON.parse(data).snapshotType_details;
  const audienceCohortType = JSON.parse(data).audienceCohortType;
  // If we returned from a child page the selected snapshot type may be in sessionStorage
  try {
    const savedSel = sessionStorage.getItem('selectedSnapshotType');
    if (savedSel) {
      const parsedSel = JSON.parse(savedSel);
      if (parsedSel && parsedSel.name) {
        this._configCustomService.selectedSnapshotType = parsedSel;
        this.selectedSnapshotType = parsedSel;
        this._configService.snapshotTypeSelectedName = parsedSel.name;
      }
    }
  } catch (e) {
    // ignore invalid session storage
  }
  
  // Assign cohortType for each snapshot that is 'Audience Snapshot'
  snapshotDetails.forEach((snapshot: any) => {
    if (snapshot?.snapshot_type?.toLowerCase() === 'audience snapshot') {
      snapshot.cohortType = audienceCohortType;
    }
    else{
      snapshot.cohortType = "NA";
    }
  });

    // Handle the "back" button logic
    if (this._configCustomService.isBack && !this._configCustomService.recievedStatusDataOnBackButtonClick?.fromBack) {
      if (this._configCustomService.recievedStatusDataOnBackButtonClick) {
        this._configCustomService.recievedStatusDataOnBackButtonClick.fromBack = this._configCustomService.isBack;
      }
    }

    // Set the selected snapshot type only after data is processed
    this._configService.snapshotTypeSelectedName =
      this._configService.snapshotTypeSelectedName || snapshotDetails[0].snapshot_type;
 snapshotDetails.forEach((item: any) => {
    item.checked = item.snapshot_type === this._configService.snapshotTypeSelectedName;
  });
    // Populate snapshot types
    this.snapshotTypes = snapshotDetails.map((item: any) => {
      item.checked = item.snapshot_type === this._configService.snapshotTypeSelectedName;
      return {
        name: item.snapshot_type,
        value: item.snapshot_type,
        cohortType: item.cohortType,
        selected: false,
      };
    });

    // Assign snapshot type data
    this.snapshotTypeData = snapshotDetails;
    this.show = true;

    // Handle setting existing snapshot types and sections when returning via back button
    if (
      this._configCustomService.selectedSnapshotType &&
      this._configCustomService.recievedStatusDataOnBackButtonClick?.fromBack
    ) {
      this._configCustomService.isBack = this._configCustomService.recievedStatusDataOnBackButtonClick.fromBack;
      // this._configCustomService.recievedStatusDataOnBackButtonClick.fromBack = false;
      this.SetAlreadyExistingSnapshotTypesandSection();
      this._configCustomService.fromBackButton = false;
      event?.stopPropagation();
    }

    // Handle snapshot type data fetching after validation
    if (this._configCustomService.selectedSnapshotType) {
      // Ensure this operation completes before toggling the chart selection container
      this.GetThisSnapshotTypeData();
      this.toggleChartSelectionContainer(false); // Disable the container
    } else {
      this.toggleChartSelectionContainer(true); // Enable the container
    }

    // Trigger change detection once everything is done
    // this.cdr.detectChanges();

    this.commonChartModule.widgets$.subscribe((widgets) => {
      // if (widgets && widgets.length > 0) {
      //   this.widgets = widgets;
      //   this.updateChartSelections();
      // }
      let data = {
        ClientName: this.clientDetails.clientDetails.client_name,
        SnapshotName: this.clientDetails.clientDetails.study
      }
      this._configCustomService.getCustomSnapshotWidgetLibrary(data).subscribe((r: any) => {

        let data = r?.Data
        if (r?.Data != "" && !this._configCustomService.recievedStatusDataOnBackButtonClick?.fromBack) {
          let findOBj = this._configCustomService.widgetSaveObjectCustom.find((w: any) => w.client_name == this._configService.clientName && w.snapshot_name == this.clientDetails.clientDetails.study);
          this.widgetList = [];
          this.cdRef.detectChanges();
          if (findOBj) {
            this._configCustomService.widgetSaveObjectCustom[0] = JSON.parse(data);
          }
          else {
            this._configCustomService.widgetSaveObjectCustom.push(JSON.parse(data));
          }

        }
        else if (r?.Data != "" && (this.isDeleteSubsection || this.isDeleteSection)) {
          let findOBj = this._configCustomService.widgetSaveObjectCustom.find((w: any) => w.client_name == this._configService.clientName && w.snapshot_name == this.clientDetails.clientDetails.study);
          this.widgetList = [];
          this.cdRef.detectChanges();
          if (findOBj) {
            this._configCustomService.widgetSaveObjectCustom[0] = JSON.parse(data);
          }
          else {
            this._configCustomService.widgetSaveObjectCustom.push(JSON.parse(data));
          }
        }


        this.chartDisplayName = this.userSelectionServiceObj.selectedChartDetails.displayName;
        this.chartId = this.userSelectionServiceObj.selectedChartDetails.chartId;
        // this.titleService.setTitle(AppConstants.applicationName + this.chartDisplayName);//update the browser title
        this.rotateBuckets();
        this.chunkCharts();

        document.querySelector(".layout-header-img")?.setAttribute("style", "display:none");
        document.querySelector(".layout-header-text")?.setAttribute("style", "margin-left:4rem;border-left:none");
        document.querySelector(".layout-header-chart-txt")?.setAttribute("style", "display:block;cursor: pointer;");
        document.querySelector(".home-icon")?.setAttribute("style", "visibility:visible")
        const headerTextElement = document.querySelector(".layout-header-chart-txt") as HTMLElement;
        if (headerTextElement) headerTextElement.textContent = this.chartDisplayName;
        document.querySelector(".layout-header-chart-arrow")?.setAttribute("style", "display:flex");
        document.querySelector(".layout-header-chartname-txt")?.setAttribute("style", "display:block;cursor: pointer;");
        const headerTextElement1 = document.querySelector(".layout-header-chartname-txt") as HTMLElement;
        if (headerTextElement1) headerTextElement1.textContent = "";
        document.querySelector(".layout-header-chart-arrow2")?.setAttribute("style", " visibility:hidden");
        if (this._configCustomService.selectedSnapshotType) {
          this.updateChartSelectedNumber();
        }
        if (this.isDeleteSubsection) {
          // this.subsectionList=[];

          this.getUniqueSectionList();
          this.getUniqueSubsectionList();

          if (this.subsectionList.length > 0 && (this.selectedSubSection == undefined || this.selectedSubSection == "")) {
            this.selectedSubSection = this.subsectionList[0].name;
          }
          let subsection = this.subsectionList.find((ss: any) => ss.name == this.selectedSubSection);
          this.isDeleteSubsection = false;
          if (subsection) {
            this.onSubSectionChange(subsection);
            this.updateChartSelectedNumber();
            this.cdRef.detectChanges();
          }
          this._loaderService.hideLoader();
        }
        if (this.isDeleteSection) {
          this.isDeleteSection = false;
          this.getUniqueSectionList();
          if (this.sectionList.length > 0 && (this.selectedSection == undefined || this.selectedSection == "")) {
            this.selectedSection = this.sectionList[0].name;
          }
          let section = this.sectionList.find((ss: any) => ss.name == this.selectedSection);
          if (section) {
            this.onSectionDropdownClick(section);
            this.updateChartSelectedNumber();
            this.cdRef.detectChanges();
          }
          this._loaderService.hideLoader();
        }


        this.cdRef.detectChanges();
        setTimeout(() => {
          if (this._configCustomService.recievedStatusDataOnBackButtonClick)
            this._configCustomService.recievedStatusDataOnBackButtonClick.fromBack = false;
          this._configCustomService.disablePreviewOnCustomizationSave = 0;
          this._configCustomService.backFromPreview = 0;
        }, 10000)


        return;
      })

    });
  }


  // Helper function to enable/disable chart selection container
  toggleChartSelectionContainer(isDisabled: boolean) {
    const chartSelectionContainer = document.querySelector('.chart-selection-container');
    if (chartSelectionContainer) {
      chartSelectionContainer.classList.toggle('disabled', isDisabled);
      this._configCustomService.isAdditionalConfig = !isDisabled;
    }
  }

  // GetThisSnapshotData = async () => {
  //   this._configService.snapshotSelectedName = this.clientDetails.clientDetails.study;
  //   try {
  //     const b = await firstValueFrom(
  //       this._configService.getClientStudyData({
  //         client_code: this.clientDetails.clientDetails.client_name,
  //         snapshot_name: this.clientDetails.clientDetails.study
  //       })
  //     );

  //     await this.getCustomProperties();
  //     if (b.body.Data != null && b.body.Data != undefined && b.body.Data != "") {
  //       if(this.isBack && !this._configCustomService.recievedStatusDataOnBackButtonClick?.fromBack){
  //         this._configCustomService.recievedStatusDataOnBackButtonClick.fromBack=this.isBack;
  //       }
  //       let a = JSON.parse(b.body.Data).snapshotType_details;

  //       this._configService.snapshotTypeSelectedName = this._configService.snapshotTypeSelectedName == undefined || this._configService.snapshotTypeSelectedName == "" ? a[0].snapshot_type : this._configService.snapshotTypeSelectedName;

  //       a.forEach((item: any) => {
  //         if (item.snapshot_type == this._configService.snapshotTypeSelectedName)
  //           item.checked = true;
  //         else
  //           item.checked = false;

  //         this.snapshotTypes.push({
  //           name: item.snapshot_type,
  //           value: item.snapshot_type,
  //           selected: false,
  //         });
  //       });

  //       this.snapshotTypeData = a;
  //       this.show = true;

  //       if((this._configCustomService.selectedSnapshotType!=undefined||'') && this._configCustomService.recievedStatusDataOnBackButtonClick.fromBack){
  //         this.isBack=this._configCustomService.recievedStatusDataOnBackButtonClick.fromBack;
  //         this._configCustomService.recievedStatusDataOnBackButtonClick.fromBack=false;
  //         this.SetAlreadyExistingSnapshotTypesandSection();
  //       }

  //       if (this.selectedSnapshotType != undefined && this.selectedSnapshotType != "" && this.selectedSnapshotType != null) {
  //         this.GetThisSnapshotTypeData();
  //         const chartSelectionContainer = document.querySelector('.chart-selection-container');
  //         if (chartSelectionContainer) {
  //           chartSelectionContainer.classList.remove('disabled');
  //         }
  //       } else {
  //         const chartSelectionContainer = document.querySelector('.chart-selection-container');
  //         if (chartSelectionContainer) {
  //           chartSelectionContainer.classList.add('disabled');
  //         }
  //         this._loaderService.hideLoader();
  //       }
  //       this.cdr.detectChanges();
  //       // 
  //       // 
  //     }
  //     //});




  //   } catch (error) {
  //     //console.error('Error fetching client study data:', error);
  //   } finally {

  //   }
  // }


  GetThisSnapshotTypeData = () => {
    try {
      // this._configService.objectFromSnapshotLayout = "";
      // const response = await firstValueFrom(
      //   this._configService.getSnapshotTypeWidgetDetails({
      //     client_code: this.clientDetails.clientDetails.client_name,
      //     snapshot_name: this.clientDetails.clientDetails.study
      //   })
      // );

      if (this._configService.fromBackButton) {
        this._configService.fromBackButton = false;
        // this._configService.WidgetLibSaveDataObject = JSON.parse(JSON.stringify(this._configService.WidgetLibSaveDataObject));
      }
      else {
        // if (response.body.Data != null && response.body.Data != undefined && response.body.Data != "") {
        // let data = JSON.parse(response.body.Data);
        this._configService.objectFromSnapshotLayout = "";
        // this._configService.WidgetLibSaveDataObject = data.filter((m: any) => m.snapshot_type == this.selectedSnapshotType); // add section and subsection also in filter
        // this._configService.WidgetLibSaveDataObject = this._configService.WidgetLibSaveDataObject[this._configService.WidgetLibSaveDataObject.length - 1];
        this.FilterDatawithTypeSectionSubSectionPlot();
        // }
        // else {
        //   // this._configService.WidgetLibSaveDataObject = [];
        // }
      }

    } catch (error) {
      //console.error('Error fetching snapshot type widget details:', error);
    }

  }

  FilterDatawithTypeSectionSubSectionPlot() {

    this.gotData = true;
    // 

    // this._configService.WidgetLibSaveDataObject = this._configService.WidgetLibSaveDataObject.filter();

    // if ((this._configService.WidgetLibSaveDataObject.length != undefined && this._configService.WidgetLibSaveDataObject.length > 0) || Object.keys(this._configService.WidgetLibSaveDataObject).length > 0) {
    //   this.widgetDetailss = this._configService.WidgetLibSaveDataObject;

    //   if (this.widgetDetailss.length > 0)
    //     this.widgetList = this._configService.processData(this.widgetDetailss[0].WidgetDetail == undefined ? this.widgetDetailss[0].WidgetDetail : this.widgetDetailss[0].WidgetDetail)
    //   else
    //     this.widgetList = this._configService.processData(this.widgetDetailss.WidgetDetail == undefined ? this.widgetDetailss.WidgetDetail : this.widgetDetailss.WidgetDetail)
    // }


    if ((this._configCustomService.widgetSaveObjectCustom.length != 0 && this._configCustomService.widgetSaveObjectCustom.length > 0)) {
      //this.widgetDetails = JSON.parse(localStorage.getItem('TotalwidgetDetailss') || ""); // Retrieve the JSON string from localStorage
      this.widgetDetails = this._configCustomService.widgetSaveObjectCustom;
      if (this.widgetDetails.length != undefined) {
        let snaphottypes = this.widgetDetails.find((w: any) => w.client_name == this._configService.clientName && w.snapshot_name == this.clientDetails.clientDetails.study);
        if (snaphottypes) {
          let snapshotType = snaphottypes.snapshotType.find((st: any) => st.snapshotType_name == this._configCustomService.selectedSnapshotType.name);
          if (snapshotType) {
            let section = snapshotType.section.find((s: any) => s.section_name == this._configCustomService.selectedSection);
            if (section) {
              let subsection = section.subsection.find((sb: any) => sb.subsection_name == ((this._configCustomService.selectedSubsection == undefined || this._configCustomService.selectedSubsection == "") ? "NA" : this._configCustomService.selectedSubsection));
              if (subsection) {
                // widgetNames = subsection.widget_detail.map((widget: any) => widget.widget_name);
                // "widgetchart_name": "Vertical Bar Chart",
                //   "widgetParentChartType": "BarChart",
                // if (this.chunkedCharts[0]) {
                //   this.chunkedCharts[0].forEach((chart: any) => {
                //     let count = 0;
                //     if (this.widgetDetails.length > 0) {
                //       if (subsection.widget_detail != undefined)
                //         count = subsection.widget_detail.filter((m: any) => chart.chartTitle?.trim().replace(/\s+/g, '').toLowerCase() === m.widgetchart_name?.trim().replace(/\s+/g, '').toLowerCase()).length;
                //       //   else
                //       //     count = this.widgetDetails[0].WidgetDetail.filter((m: any) => chart.chartTitle?.trim().replace(/\s+/g, '').toLowerCase() === m.widgetchartname?.trim().replace(/\s+/g, '').toLowerCase()).length;

                //       //   if (this.widgetDetails[0].WidgetDetail == undefined && this.widgetDetails[0].WidgetDetail != undefined)
                //       //     count = this.widgetDetails[0].WidgetDetail.filter((m: any) => chart.chartTitle?.trim().replace(/\s+/g, '').toLowerCase() === m.widgetchartname?.trim().replace(/\s+/g, '').toLowerCase()).length;
                //       //   else if (this.widgetDetails[0].WidgetDetail != undefined && this.widgetDetails[0].WidgetDetail == undefined)
                //       //     count = this.widgetDetails[0].WidgetDetail.filter((m: any) => chart.chartTitle?.trim().replace(/\s+/g, '').toLowerCase() === m.widgetchartname?.trim().replace(/\s+/g, '').toLowerCase()).length;
                //     }
                //     chart.chartSelectedNumber = count > 0 ? count : 0;
                //   });
                // }
                // if (this.chunkedCharts[1]) {
                //   this.chunkedCharts[1].forEach((chart: any) => {
                //     let count = 0;
                //     if (this.widgetDetails.length > 0) {
                //       if (subsection.widget_detail != undefined)
                //         count = subsection.widget_detail.filter((m: any) => chart.chartTitle?.trim().replace(/\s+/g, '').toLowerCase() === m.widgetchart_name?.trim().replace(/\s+/g, '').toLowerCase()).length;
                //       //   else
                //       //     count = this.widgetDetails[0].WidgetDetail.filter((m: any) => chart.chartTitle?.trim().replace(/\s+/g, '').toLowerCase() === m.widgetchartname?.trim().replace(/\s+/g, '').toLowerCase()).length;

                //       //   if (this.widgetDetails[0].WidgetDetail == undefined && this.widgetDetails[0].WidgetDetail != undefined)
                //       //     count = this.widgetDetails[0].WidgetDetail.filter((m: any) => chart.chartTitle?.trim().replace(/\s+/g, '').toLowerCase() === m.widgetchartname?.trim().replace(/\s+/g, '').toLowerCase()).length;
                //       //   else if (this.widgetDetails[0].WidgetDetail != undefined && this.widgetDetails[0].WidgetDetail == undefined)
                //       //     count = this.widgetDetails[0].WidgetDetail.filter((m: any) => chart.chartTitle?.trim().replace(/\s+/g, '').toLowerCase() === m.widgetchartname?.trim().replace(/\s+/g, '').toLowerCase()).length;
                //     }
                //     chart.chartSelectedNumber = count > 0 ? count : 0;
                //   });
                // }
                this.availableCharts.forEach((chart: any) => {
                  let count = 0;
                  if (subsection.widget_detail != undefined) {
                    //count = subsection.widget_detail.filter((m: any) => chart.displayName.trim().replace(/\s+/g, '').toLowerCase() === m.widgetParentChartType.trim().replace(/\s+/g, '').toLowerCase()).length;
                    let a = subsection.widget_detail.filter((m: any) => {
                      if (m.widgetParentChartType.trim().replace(/\s+/g, '').toLowerCase() == "tableview")
                        return chart.displayName.trim().replace(/\s+/g, '').toLowerCase() === "others";
                      else
                        return chart.displayName.trim().replace(/\s+/g, '').toLowerCase() === m.widgetParentChartType.trim().replace(/\s+/g, '').toLowerCase();
                    });
                    count = a.length;
                  }
                  else
                    count = subsection.widget_detail.filter((m: any) => chart.displayName.trim().replace(/\s+/g, '').toLowerCase() === m.widgetParentChartType.trim().replace(/\s+/g, '').toLowerCase()).length;
                  chart.chartSelectedNumber = count > 0 ? count : 0;

                });
              }
              else {
                //   if (this.chunkedCharts[0]) {
                //     this.chunkedCharts[0].forEach((chart: any) => {
                //       let count = 0;
                //       if (this.widgetDetails.length > 0) {
                //         count = 0;
                //       }
                //       chart.chartSelectedNumber = count > 0 ? count : 0;
                //     });
                //   }
                //   if (this.chunkedCharts[1]) {
                //     this.chunkedCharts[1].forEach((chart: any) => {
                //       let count = 0;
                //       if (this.widgetDetails.length > 0) {
                //         if (subsection.widget_detail != undefined)
                //           count = subsection.widget_detail.filter((m: any) => chart.chartTitle?.trim().replace(/\s+/g, '').toLowerCase() === m.widgetchart_name?.trim().replace(/\s+/g, '').toLowerCase()).length;
                //         //   else
                //         //     count = this.widgetDetails[0].WidgetDetail.filter((m: any) => chart.chartTitle?.trim().replace(/\s+/g, '').toLowerCase() === m.widgetchartname?.trim().replace(/\s+/g, '').toLowerCase()).length;

                //         //   if (this.widgetDetails[0].WidgetDetail == undefined && this.widgetDetails[0].WidgetDetail != undefined)
                //         //     count = this.widgetDetails[0].WidgetDetail.filter((m: any) => chart.chartTitle?.trim().replace(/\s+/g, '').toLowerCase() === m.widgetchartname?.trim().replace(/\s+/g, '').toLowerCase()).length;
                //         //   else if (this.widgetDetails[0].WidgetDetail != undefined && this.widgetDetails[0].WidgetDetail == undefined)
                //         //     count = this.widgetDetails[0].WidgetDetail.filter((m: any) => chart.chartTitle?.trim().replace(/\s+/g, '').toLowerCase() === m.widgetchartname?.trim().replace(/\s+/g, '').toLowerCase()).length;
                //       }
                //       chart.chartSelectedNumber = count > 0 ? count : 0;
                //     });
                //   }
                // }
                this.availableCharts.forEach((chart: any) => {
                  let count = 0;
                  if (subsection.widget_detail != undefined)
                    count = 0;
                  else
                    count = 0;
                  chart.chartSelectedNumber = count > 0 ? count : 0;

                });
              }
            }
            else {
              this.availableCharts.forEach((chart: any) => {
                chart.chartSelectedNumber = 0;
              });
              // this.chunkedCharts[0].forEach((chart: any) => {
              //   let count = 0;
              //   if (this.widgetDetails.length > 0) {
              //     count = 0;
              //   }
              //   chart.chartSelectedNumber = count > 0 ? count : 0;
              // });
            }
          }
        }
      }
    }
    // if (this._configService.WidgetLibSaveDataObject != null && this._configService.WidgetLibSaveDataObject != undefined) {
    //   localStorage.setItem('TotalwidgetDetailss', JSON.stringify(this._configService.WidgetLibSaveDataObject));


    //   // if (localStorage.getItem('TotalwidgetDetailss')) {            
    //   //     this.widgetDetails = JSON.parse(localStorage.getItem('TotalwidgetDetailss') || "");

    //   if ((this._configService.WidgetLibSaveDataObject.length != undefined && this._configService.WidgetLibSaveDataObject.length > 0) || Object.keys(this._configService.WidgetLibSaveDataObject).length > 0) {
    //     this.widgetDetails = this._configService.WidgetLibSaveDataObject;
    //     //this.widgetDetails = this.widgetDetails.filter((m: any) => m.snapshot_type == this._configService.snapshotTypeSelectedName);


    //     this.availableCharts.forEach((chart: any) => {
    //       let count = 0;
    //       if (this.widgetDetails[0]?.WidgetDetail == undefined)
    //         count = this.widgetDetails[0]?.WidgetDetail.filter((m: any) => chart.displayName.trim().replace(/\s+/g, '').toLowerCase() === m.widgetparentchartType.trim().replace(/\s+/g, '').toLowerCase()).length;
    //       else
    //         count = this.widgetDetails[0]?.WidgetDetail.filter((m: any) => chart.displayName.trim().replace(/\s+/g, '').toLowerCase() === m.widgetparentchartType.trim().replace(/\s+/g, '').toLowerCase()).length;
    //       chart.chartSelectedNumber = count > 0 ? count : 0;

    //     });

    //     this.cdr.detectChanges();
    //   }

    // }

    // else {
    //   localStorage.setItem('TotalwidgetDetailss', "");
    // }
    this.enableWidgetsOnStudy();

  }

  // ngOnDestroy(): void {
  //   if (this.subscription) {
  //     this.subscription.unsubscribe();
  //   }
  // }
  updateChartSelections() {
     let widgets = this.widgets.filter((w: any) => {
    const selectedSnapshot = this.snapshotTypeData.find((st: any) => st.checked === true);
    const snapshotTypeMatch = w.SnapshotType.replace(/\s+/g, '').toLowerCase() == selectedSnapshot.snapshot_type.replace(/\s+/g, '').toLowerCase();
    
    // Only apply cohortTypeMatch if snapshot_type is 'Audience Snapshot'
    if (selectedSnapshot.snapshot_type?.toLowerCase() === 'audience snapshot' && snapshotTypeMatch) {
      let cohortTypeMatch = true;
      if (w.cohortType && w.cohortType.trim() !== '') {
        cohortTypeMatch = w.cohortType.toLowerCase() === this.audienceCohortType?.toLowerCase();
      }
      return snapshotTypeMatch && cohortTypeMatch;
    } else {
      // For non-Audience snapshots, only check snapshotTypeMatch
      return snapshotTypeMatch;
    }
  });
    if (widgets.length > 0) {
      let availableCharts = LandingConstants.availableCharts;
      // Get all available charts based on selected category
      let chartSelection = this.userSelectionServiceObj.getAvailableChartSelectionBasedOnChartCategory();
      this.availableChartForSelection = chartSelection.map((c: any) => ({ ...c })); // deep copy
      
      //this.availableChartForSelection = chartSelection;
      
      this.availableChartForSelection.forEach(chart => {
        for (const widget of widgets) {
          if (!chart.chartTitle.trim().replace(/\s+/g, '').toLowerCase().includes(widget.Chart.trim().replace(/\s+/g, '').toLowerCase())) {
            chart.isEnabled = false;
          } else {
            chart.isEnabled = true;
            break;
          }
        }
      });
      
      // to disable scatter and bubble
      this.availableChartForSelection.forEach(chart => {
        if (chart.chartTitle == "Scatter Chart DN" || chart.chartTitle == "Bubble Chart DN") {
          chart.isEnabled = false;
        }
      });
      
      this.availableChartForSelection = this.availableChartForSelection.filter((chart: any) => {
               return widgets.some((widget: any) => {
          const chartTitle = chart.chartTitle.trim().replace(/\s+/g, '').toLowerCase();
          const widgetChart = widget.Chart.trim().replace(/\s+/g, '').toLowerCase();
          // Check bidirectional match
          return chartTitle.includes(widgetChart) || widgetChart.includes(chartTitle);
        });
      });
            //this.availableChartForSelection = this.availableChartForSelection.filter((bucket: any) => {
      //   return widgets.some((widget: any) => {
      //     const chartTitle = chart.chartTitle.trim().replace(/\s+/g, '').toLowerCase();
      //     const widgetChart = widget.Chart.trim().replace(/\s+/g, '').toLowerCase();
      //     // Check bidirectional match
      //     return chartTitle.includes(widgetChart) || widgetChart.includes(chartTitle);
      //   });
      // });
      
      // availableCharts.sort((a: any, b: any) => {
      //   // Check if sorting is undefined or null for each object
      //   const aSorting = a.sorting ?? Infinity; // Use Infinity to push missing values to the end
      //   const bSorting = b.sorting ?? Infinity;

      //   // Sort based on the adjusted sorting values
      //   return aSorting - bSorting;
      // });
       this.availableCharts = availableCharts.filter((bucket: any) => {
        const normalizedBucketName = bucket.displayName.trim().replace(/\s+/g, '').toLowerCase();
        return widgets.some((widget: any) => {
          const normalizedChartGroup = widget.ChartGroup.trim().replace(/\s+/g, '').toLowerCase();
          // Direct match - this handles "Stack bar Chart" == "Stack bar chart"
          return normalizedBucketName === normalizedChartGroup;
        });
      })
    }
    else {
      this.availableChartForSelection = [];
      this.availableCharts = [];
    }

    this.cdRef.detectChanges();
    this.rotateBuckets();
    this.chunkCharts();
  }

  goBackToLandingPage(event: any) {
    this.routerObj.navigate(["/Landing"]);//go back to landing page
  }
  goToChartSelection($event: any) {
    this.availableChartForSelection = this.userSelectionServiceObj.getAvailableChartSelectionBasedOnChartCategory();
    this.chartDisplayName = this.userSelectionServiceObj.selectedChartDetails.displayName;
    const headerTextElement = document.querySelector(".layout-header-chart-txt") as HTMLElement;
    if (headerTextElement) { headerTextElement.textContent = this.chartDisplayName; }
    this.chartId = this.userSelectionServiceObj.selectedChartDetails.chartId;
    this.carouselView = false;
    this.centerIndex = 1;
    // this.titleService.setTitle(AppConstants.applicationName + this.chartDisplayName);//update the browser title
    this.rotateBuckets();
    this.chunkCharts();

    this.updateChartSelections();
  }

  displayChart(routePath: string, chartDescription: string[], chartFolderPath: string, idx: number) {
    //decimal pipe with 2.0 makes sure that barchart number has atleast 2 decimal digits
    let selectedChartTitle = this.decimalPipe.transform(idx.toString(), "2.0") + "/" + this.chartDisplayName.toUpperCase();
    //update the userSelectionsObj using service 
    this.userSelectionServiceObj.updateUserSelections({ "routePath": routePath, "routePath2": "", "selectedChartTitle": selectedChartTitle, "description": chartDescription, "chartFolderPath": chartFolderPath, "chartFolderPath2": "" });
    this.routerObj.navigate(["/" + routePath]);//navigate to selected chart   
  }

  rotateBuckets() {
    const bucketCount = this.availableChartForSelection.length;
    const maxBucketsToShow = 3;

    if (bucketCount <= maxBucketsToShow) {
      this.bucketsToShow = this.availableChartForSelection;
    }
    else {
      // Calculate the start and end indices for the buckets to be shown
      const startIndex = (this.centerIndex - Math.floor(maxBucketsToShow / 2) + bucketCount) % bucketCount;
      let endIndex = (startIndex + maxBucketsToShow) % bucketCount;

      if (startIndex > endIndex) {
        // Adjust the endIndex to handle wrap-around when startIndex is greater
        endIndex += bucketCount;
      }

      // Get the buckets within the calculated range
      this.bucketsToShow = this.getBucketsInRange(startIndex, endIndex);

      // Update the centerIndex for the next rotation
      //this.centerIndex = (this.centerIndex + 1) % bucketCount;


    }
    // Set the currentBucketId to the chartId of the center bucket in the visible range, if available
    //this.currentBucketId = this.bucketsToShow.length > 0 ? this.bucketsToShow[Math.floor(this.bucketsToShow.length / 2)].chartId : null;

    this.currentBucketId = this.bucketsToShow.length > 0 ?
      (this.bucketsToShow.length === 2 ?
        this.bucketsToShow[this.centerIndex].chartId :
        this.bucketsToShow[Math.floor(this.bucketsToShow.length / 2)].chartId)
      : null;
  }

  getBucketsInRange(startIndex: number, endIndex: number): any[] {
    const result: any[] = [];
    const bucketCount = this.availableChartForSelection.length;

    for (let i = startIndex; i < endIndex; i++) {
      const adjustedIndex = (i + bucketCount) % bucketCount;
      result.push(this.availableChartForSelection[adjustedIndex]);
    }
    return result;
  }

  prev() {
    this.centerIndex = (this.centerIndex - 1 + this.availableChartForSelection.length) % this.availableChartForSelection.length;
    this.rotateBuckets();
  }

  next() {
    this.centerIndex = (this.centerIndex + 1) % this.availableChartForSelection.length;
    this.rotateBuckets();
  }
  exploreClick(chart: any, widgetName: string = '') {
    this._configCustomService.showPreviewStatus = this.showPreview;
    sessionStorage.setItem('isFromParent', 'true');
    let countofWidgets = 0;
    let widgetEditSelection: any;
    if ((this._configCustomService.widgetSaveObjectCustom.length != 0 && this._configCustomService.widgetSaveObjectCustom.length > 0)) {
      //this.widgetDetails = JSON.parse(localStorage.getItem('TotalwidgetDetailss') || ""); // Retrieve the JSON string from localStorage
      this.widgetDetails = this._configCustomService.widgetSaveObjectCustom;
      if (this.widgetDetails.length != undefined) {
        let snaphottypes = this.widgetDetails.find((w: any) => w.client_name == this._configService.clientName && w.snapshot_name == this.clientDetails.clientDetails.study);
        if (snaphottypes) {
          let snapshotType = snaphottypes.snapshotType.find((st: any) => st.snapshotType_name == this._configCustomService.selectedSnapshotType.name);
          if (snapshotType) {
            let section = snapshotType.section.find((s: any) => s.section_name == this._configCustomService.selectedSection);
            if (section) {
              let subsection = section.subsection.find((sb: any) => sb.subsection_name == ((this._configCustomService.selectedSubsection == undefined || this._configCustomService.selectedSubsection == "") ? "NA" : this._configCustomService.selectedSubsection));
              if (subsection) {
                countofWidgets = subsection.widget_detail?.filter((w: any) => w.widgetParentChartType != "LineChart").length;
                widgetEditSelection = subsection.widget_detail.find((a: any) => a.widget_name == widgetName);
              }
            }
          }
        }
      }
    }
    if (countofWidgets <= this._configCustomService.maxWidgetSelection) {
      this.userSelectionServiceObj.updateUserSelections({ "routePath": chart.routePath, "routePath2": chart.routePath2, "selectedChartTitle": chart.chartTitle, "description": [], "chartFolderPath": chart.chartFolderPath, "chartFolderPath2": chart.chartFolderPath2 });
      const navigationExtras: NavigationExtras = {
        state: {
          userData: {
            routePath: chart.routePath,
            routePath2: chart.routePath2,
            selectedChartTitle: chart.chartTitle,
            description: [],
            chartFolderPath: chart.chartFolderPath,
            chartFolderPath2: chart.chartFolderPath2,
            widgetEditSelection: widgetEditSelection
          }
        }
      };
      //this.userSelectionServiceObj.updateUserSelectionsChartDetails(chart);
      this.routerObj.navigate(["/Snapshot/" + chart.routePath], navigationExtras);//navigate to selected chart 
    }
    else {
      this.showErrorPopUp = true;
      this.errorheaderTitle = "Info";
      this.popUpMessage = "Maximum Widget Limit of 16 Visuals is reached! Please delete a Visual to configure another";
    }
  }
  changeDisplayView() {
    this.carouselView = !this.carouselView;
    if (this.carouselView) {
      this.titleName = "Carousel View"
    }
    else {
      this.titleName = "Grid View"
    }
  }
  chunkCharts() {
    this.chunkedCharts = [];
    const chunkSize = 5;

    for (let i = 0; i < this.availableChartForSelection.length; i += chunkSize) {
      this.chunkedCharts.push(this.availableChartForSelection.slice(i, i + chunkSize));
    }
    if (this._configCustomService.selectedSnapshotType) {
      this.updateChartSelectedNumber();
    }
    this.CheckCountForPreviewEnable();
  }
  updateSelectionDetails(selectedChart: LandingCardInterface) {
    this.userSelectionServiceObj.updateUserSelections(selectedChart);//update the userSelections using service
  }
  editWidget(event: any) {
    this.availableCharts.forEach((element: any) => {
      if (element.displayName.replace(/\s+/g, '').toLowerCase() === "others") {
        if (event.parent.replace(/\s+/g, '').toLowerCase() === "tableview") {
          this.updateSelectionDetails(element);
        }
        else if (element.displayName.replace(/\s+/g, '').toLowerCase() === event.parent.replace(/\s+/g, '').toLowerCase()) {
          this.updateSelectionDetails(element);
        }
      }
      else if (element.displayName.replace(/\s+/g, '').toLowerCase() === event.parent.replace(/\s+/g, '').toLowerCase()) {
        this.updateSelectionDetails(element);
      }
    });
    this.goToChartSelection("");
    let chunkedChartsLength = this.chunkedCharts.length;
    let selection: any;
    for (let i = 0; i < chunkedChartsLength; i++) {
      let sel = this.chunkedCharts[i].find((a: any) => a.chartTitle == event.visualization);
      if (sel != undefined) {
        selection = sel;
      }
    }
    this.exploreClick(selection, event.widgetName);
  }
  newListfromVisualSelect(data: any) {
    this.widgetList = data;
    if (this._configCustomService.widgetSaveObjectCustom.length > 0)
      this._configCustomService.widgetSaveObjectCustom = [this._configCustomService.modifyWidgetsForSpecificSnapshotSection(
        this._configCustomService.widgetSaveObjectCustom[0],
        this._configCustomService.selectedSnapshotType.name,
        this._configCustomService.selectedSection,
        (this._configCustomService.selectedSubsection == undefined || this._configCustomService.selectedSubsection == "") ? "NA" : this._configCustomService.selectedSubsection,
        this.widgetList
      )]
    // this.widgetDetailss.WidgetDetail = this.widgetDetailss.WidgetDetail.filter((detail: any) => {
    //   for (let i = 0; i < this.widgetList.length; i++) {
    //     if (this.widgetList[i].widgetName === detail.widget_name) {
    //       return true;
    //     }
    //   }
    //   return false;
    // });
    localStorage.setItem('TotalwidgetDetailss', JSON.stringify(this.widgetDetailss));
    // this._configService.WidgetLibSaveDataObject=this.widgetDetailss;

    this._configCustomService.checkDeleteClick = 1;
    this.showPreview = false; //disabling preview while deleting the visual select list.
    this.updateChartSelectedNumber();
    // this.chunkedCharts.forEach((c1: any) => {
    //   c1.forEach((c: any) => {
    //     if (c.chartTitle == this._configService.widgetNametoDelete) {
    //       if (c.chartSelectedNumber > 0) {
    //         c.chartSelectedNumber -= 1;
    //         const foundChart = this.availableCharts.find((m: any) => m.displayName.toLowerCase() == c.chartGroup.toLowerCase());
    //         if (foundChart && foundChart.chartSelectedNumber) {
    //           foundChart.chartSelectedNumber -= 1;
    //         }
    //       }
    //     }
    //   })
    // })


    this.cdRef.detectChanges();
  }

  // widgetList = [
  //   {
  //     widgetName: "Trend of Metric 2",
  //     visualization: "Trend Chart",
  //     image: "",
  //     active: false
  //   },
  //   {
  //     widgetName: "Brand Power Grid",
  //     visualization: "Bubble Chart",
  //     image: "https://upload.wikimedia.org/wikipedia/en/a/af/Star_Wars_The_Rise_of_Skywalker_poster.jpg",
  //     active: false
  //   },
  //   {
  //     widgetName: "Unaided awareness",
  //     visualization: "01/Pie Chart",
  //     image: "",
  //     active: false
  //   },
  //   {
  //     widgetName: "Imagery Statements",
  //     visualization: "Horizontal Bar",
  //     image: "",
  //     active: false
  //   }

  // ]

  typeDropdownPopup: boolean = false;
  sectionDropdownPopup: boolean = false;
  subSectionDropdownPopup: boolean = false;

  openTypeDropdown(event: Event): void {
    //Making preview disable initially on snapshotType click;
    this.showPreview = false;

    this.typeDropdownPopup = !this.typeDropdownPopup;
    this.sectionDropdownPopup = false;
    this.subSectionDropdownPopup = false;
    event.stopPropagation();
  }
  closeTypeDropdown(): void {
    this.typeDropdownPopup = false;
    this.sectionDropdownPopup = false;
    this.subSectionDropdownPopup = false;
  }
  closeSectionDropdown() {
    this.sectionDropdownPopup = false;
  }
  closeSubsectionDropdown() {
    this.subSectionDropdownPopup = false;
  }

  sectionDisable: boolean = true;
  subSectionDisable: boolean = true;

  selectedSection: any = null;
  selectedSubSection: any = "";
  isWidgetTypeSectionsConfigured: boolean = false;
  sections: any[] = [];
  subSections: any[] = [];
  sectionHeader: string = 'Sections';
  subSectionHeader: string = 'Sub Section';

  onTypeClick(item: any) {
    if (this.selectedSnapshotType?.name != item.name) {
      this.widgetList = [];
      this.cdRef.detectChanges();
      this.typeHeader = item.name;
      this.previousSection = this.selectedSection;
      this.selectedSection = "";
      this.selectedSubSection = "";
      this._configCustomService.selectedSection = "";
      this._configCustomService.selectedSubsection = "";
      this.subSectionHeader = "Sub Section";
      const subsectionBlock = document.querySelector('.widget-items.subsection-block');
      // if (this.selectedSection != "" || undefined && input != null || "") {
      if (subsectionBlock) {
        subsectionBlock.classList.add('disabled');
      }
      this.subsectionList = [];
      const chartSelectionContainer = document.querySelector('.chart-selection-container');
      chartSelectionContainer?.classList.add('disabled');
          for (let i = 0; i < this.snapshotTypes.length; i++) {
      if (this.snapshotTypes[i] === item) {
        this.snapshotTypes[i].selected = true;
      } else {
        this.snapshotTypes[i].selected = false;
      }
    }
    //If nothing is selected in snapshot type dropdown then disbale the section and subSection
    let count = 0;
    for (let z = 0; z < this.snapshotTypes.length; z++) {
      if (this.snapshotTypes[z].selected == true) {
        count++;
      }
    }
    if (count == 0) {
      this.sectionDisable = true;
      this.subSectionDisable = true;
      this.sections = [];
      this.subSections = [];
    } else {
      this.subSections = [];
    }

    // ------Find the selected snapshot type
    const selectedSnapshotType = this.snapshotTypes.find(
      (snapshotType) => snapshotType.selected
    );
    // this.widgetList = [];
    this.selectedSnapshotType = selectedSnapshotType;
        this._configCustomService.selectedSnapshotType = this.selectedSnapshotType;
        this._configService.snapshotTypeSelectedName = this.selectedSnapshotType?.name;
       this.snapshotTypeData.forEach((item: any) => {
    item.checked = item.snapshot_type === this._configCustomService.selectedSnapshotType.name ;
  });
      this._configCustomService.isAdditionalConfig = false;
      if (this.availableCharts.length > 0 && !this._configCustomService.recievedStatusDataOnBackButtonClick?.fromBack) {
        this.availableCharts.forEach((element: any) => {
          if (element.displayName.replace(/\s+/g, '').toLowerCase() === "barchart") {
            this.updateSelectionDetails(element);
          }
        });
    //         const selectedSnapshotType = this.snapshotTypes.find(
    //   (snapshotType) => snapshotType.selected
    // );
        this.goToChartSelection("");
      }
      // let chunkedChartsLength = this.chunkedCharts.length;
      // let selection: any;
      // for (let i = 0; i < chunkedChartsLength; i++) {
      //   let sel = this.chunkedCharts[i].find((a: any) => a.chartTitle == event.visualization);
      //   if (sel != undefined) {
      //     selection = sel;
      //   }
      // }
    }
    for (let i = 0; i < this.snapshotTypes.length; i++) {
      if (this.snapshotTypes[i] === item) {
        this.snapshotTypes[i].selected = true;
      } else {
        this.snapshotTypes[i].selected = false;
      }
    }
    //If nothing is selected in snapshot type dropdown then disbale the section and subSection
    let count = 0;
    for (let z = 0; z < this.snapshotTypes.length; z++) {
      if (this.snapshotTypes[z].selected == true) {
        count++;
      }
    }
    if (count == 0) {
      this.sectionDisable = true;
      this.subSectionDisable = true;
      this.sections = [];
      this.subSections = [];
    } else {
      this.subSections = [];
    }

    // ------Find the selected snapshot type
    const selectedSnapshotType = this.snapshotTypes.find(
      (snapshotType) => snapshotType.selected
    );
    // this.widgetList = [];
    this.selectedSnapshotType = selectedSnapshotType;
        this._configCustomService.selectedSnapshotType = this.selectedSnapshotType;
        this._configService.snapshotTypeSelectedName = this.selectedSnapshotType?.name;
       this.snapshotTypeData.forEach((item: any) => {
    item.checked = item.snapshot_type === this._configCustomService.selectedSnapshotType.name ;
  });
    this.updateChartSelections();
    this.cdRef.detectChanges();

    this.getUniqueSectionList();

    this.cdRef.detectChanges();

    //Showing selected snapshot type in main dropdown div
    for (let k = 0; k < this.snapshotTypes.length; k++) {
      if (this.snapshotTypes[k].selected == true) {
        this.typeHeader = this.snapshotTypes[k].name;
        this.sectionHeader = 'Sections';
        this.subSectionHeader = 'Sub Section';
      }
    }
// Close dropdown after selection
this.typeDropdownPopup = false;
    //  this.GetThisSnapshotTypeData();
    this.GetThisSnapshotTypeData();
    const sectionBlock = document.querySelector('.widget-items.section-block');
    if (sectionBlock) {
      sectionBlock.classList.remove('disabled');
    }
    this.showPreview = false;//disabling preview on type click
    const previewbtn = document.querySelector('.preview-button');
    if (previewbtn) previewbtn.classList.add('disabled');
    const headerTextElement = document.querySelector(".layout-header-chart-txt") as HTMLElement;
    if (headerTextElement) headerTextElement.textContent = this.chartDisplayName;
  }

  redirecToPreviewPage() {
    if (this.widgetList != 0) {
      sessionStorage.setItem('isFromParent', 'true');
      //binding get data for Preview
      // if (this._configService.objectFromSnapshotLayout == "") {
      let data = {
        ClientName: this.clientDetails.clientDetails.client_name,
        SnapshotName: this.clientDetails.clientDetails.study
      }

      let specificData = {
        SnapshotType: this._configCustomService.selectedSnapshotType.name,
        SectionName: this._configCustomService.selectedSection,
        SubSectionName: (this._configCustomService.selectedSubsection == undefined || this._configCustomService.selectedSubsection == "") ? "NA" : this._configCustomService.selectedSubsection
      }

      // localStorage.setItem("clientInfo",JSON.stringify(data));
      // localStorage.setItem("clientSpecific",JSON.stringify(specificData));
      var tempArr: any = []
      this._configCustomService.getCustomSnapshotWidgetLibrary(data).subscribe((r: any) => {

        let data = r?.Data
        if (r?.Data != "") {
          tempArr.push(JSON.parse(data));
        }
        // if (r?.Data != "" && !this._configCustomService.recievedStatusDataOnBackButtonClick?.fromBack) {

        var x = tempArr[0].snapshotType;
        let layoutDetails = [];

        for (let i = 0; i < x.length; i++) {
          if (x[i].snapshotType_name === this._configCustomService.selectedSnapshotType.name) {
            for (let j = 0; j < x[i].section.length; j++) {
              if (x[i].section[j].section_name === this._configCustomService.selectedSection) {
                for (let k = 0; k < x[i].section[j].subsection.length; k++) {
                  if (x[i].section[j].subsection[k].subsection_name ===
                    ((this._configCustomService.selectedSubsection == undefined || this._configCustomService.selectedSubsection == "") ? "NA" : this._configCustomService.selectedSubsection)) {
                    layoutDetails = x[i].section[j].subsection[k].page_details;
                  }
                }
              }
            }
          }
        }



        this._configCustomService.dataFromPageDetailForPreview = layoutDetails; //variable used only while binding back
        this._configCustomService.widgetSaveObjectCustomForPreview = tempArr;

        const dataToSend = { widgetConfigured: this.widgetList.length };
        this.routerObj.navigateByUrl('Snapshot/snapshotpreview', { state: { data: dataToSend } })
      });
    }
    else {
      this.showPreview = false;
      const previewbtn = document.querySelector('.preview-button');
      if (previewbtn) previewbtn.classList.add('disabled');
      this.cdRef.detectChanges();
      return;
    }



    // else {
    //   const dataToSend = { widgetConfigured: this.widgetList.length };
    //   this.routerObj.navigateByUrl('Snapshot/snapshotpreview', { state: { data: dataToSend } })
    // }

    // const dataToSend = { widgetConfigured: this.widgetList.length };
    // this.routerObj.navigateByUrl('Snapshot/snapshotpreview', { state: { data: dataToSend } })
  }


  widgetDetails: any;

  updateChartSelectedNumber() { // Declare widgetDetails as an array

    if ((this._configCustomService.widgetSaveObjectCustom.length != 0 && this._configCustomService.widgetSaveObjectCustom.length > 0)) {
      //this.widgetDetails = JSON.parse(localStorage.getItem('TotalwidgetDetailss') || ""); // Retrieve the JSON string from localStorage
      this.widgetDetails = this._configCustomService.widgetSaveObjectCustom;
      if (this.widgetDetails.length != undefined) {
        let snaphottypes = this.widgetDetails.find((w: any) => w.client_name == this._configService.clientName && w.snapshot_name == this.clientDetails.clientDetails.study);
        if (snaphottypes) {
          let snapshotType = snaphottypes.snapshotType.find((st: any) => st.snapshotType_name == this.selectedSnapshotType?.name);
          if (snapshotType) {
            let section = snapshotType.section.find((s: any) => s.section_name == this._configCustomService.selectedSection);
            if (section) {
              let subsection = section.subsection.find((sb: any) => sb.subsection_name == ((this._configCustomService.selectedSubsection == undefined || this._configCustomService.selectedSubsection == "") ? "NA" : this._configCustomService.selectedSubsection));
              if (subsection) {
                // widgetNames = subsection.widget_detail.map((widget: any) => widget.widget_name);
                // "widgetchart_name": "Vertical Bar Chart",
                //   "widgetParentChartType": "BarChart",
                this.countofWidgets = subsection.widget_detail?.filter((w: any) => w.widgetParentChartType != "LineChart").length;
                if (this.chunkedCharts[0]) {
                  this.chunkedCharts[0].forEach((chart: any) => {
                    let count = 0;
                    if (this.widgetDetails.length > 0) {
                      if (subsection.widget_detail != undefined)
                        count = subsection.widget_detail?.filter((w: any) => w.widgetParentChartType != "LineChart")?.filter((m: any) => chart.chartTitle?.trim().replace(/\s+/g, '').toLowerCase() === m.widgetchart_name?.trim().replace(/\s+/g, '').toLowerCase()).length;
                      //   else
                      //     count = this.widgetDetails[0].WidgetDetail.filter((m: any) => chart.chartTitle?.trim().replace(/\s+/g, '').toLowerCase() === m.widgetchartname?.trim().replace(/\s+/g, '').toLowerCase()).length;

                      //   if (this.widgetDetails[0].WidgetDetail == undefined && this.widgetDetails[0].WidgetDetail != undefined)
                      //     count = this.widgetDetails[0].WidgetDetail.filter((m: any) => chart.chartTitle?.trim().replace(/\s+/g, '').toLowerCase() === m.widgetchartname?.trim().replace(/\s+/g, '').toLowerCase()).length;
                      //   else if (this.widgetDetails[0].WidgetDetail != undefined && this.widgetDetails[0].WidgetDetail == undefined)
                      //     count = this.widgetDetails[0].WidgetDetail.filter((m: any) => chart.chartTitle?.trim().replace(/\s+/g, '').toLowerCase() === m.widgetchartname?.trim().replace(/\s+/g, '').toLowerCase()).length;
                    }
                    chart.chartSelectedNumber = count > 0 ? count : 0;
                  });
                }
                if (this.chunkedCharts[1]) {
                  this.chunkedCharts[1].forEach((chart: any) => {
                    let count = 0;
                    if (this.widgetDetails.length > 0) {
                      if (subsection.widget_detail != undefined)
                        count = subsection.widget_detail?.filter((w: any) => w.widgetParentChartType != "LineChart").filter((m: any) => chart.chartTitle?.trim().replace(/\s+/g, '').toLowerCase() === m.widgetchart_name?.trim().replace(/\s+/g, '').toLowerCase()).length;
                      //   else
                      //     count = this.widgetDetails[0].WidgetDetail.filter((m: any) => chart.chartTitle?.trim().replace(/\s+/g, '').toLowerCase() === m.widgetchartname?.trim().replace(/\s+/g, '').toLowerCase()).length;

                      //   if (this.widgetDetails[0].WidgetDetail == undefined && this.widgetDetails[0].WidgetDetail != undefined)
                      //     count = this.widgetDetails[0].WidgetDetail.filter((m: any) => chart.chartTitle?.trim().replace(/\s+/g, '').toLowerCase() === m.widgetchartname?.trim().replace(/\s+/g, '').toLowerCase()).length;
                      //   else if (this.widgetDetails[0].WidgetDetail != undefined && this.widgetDetails[0].WidgetDetail == undefined)
                      //     count = this.widgetDetails[0].WidgetDetail.filter((m: any) => chart.chartTitle?.trim().replace(/\s+/g, '').toLowerCase() === m.widgetchartname?.trim().replace(/\s+/g, '').toLowerCase()).length;
                    }
                    chart.chartSelectedNumber = count > 0 ? count : 0;
                  });
                }
              }
              else {
                if (this.chunkedCharts[0]) {
                  this.chunkedCharts[0].forEach((chart: any) => {
                    let count = 0;
                    if (this.widgetDetails.length > 0) {
                      count = 0;
                    }
                    chart.chartSelectedNumber = count > 0 ? count : 0;
                  });
                }
                if (this.chunkedCharts[1]) {
                  this.chunkedCharts[1].forEach((chart: any) => {
                    let count = 0;
                    if (this.widgetDetails.length > 0) {
                      if (subsection?.widget_detail != undefined)
                        count = subsection.widget_detail?.filter((w: any) => w.widgetParentChartType != "LineChart").filter((m: any) => chart.chartTitle?.trim().replace(/\s+/g, '').toLowerCase() === m.widgetchart_name?.trim().replace(/\s+/g, '').toLowerCase()).length;
                      //   else
                      //     count = this.widgetDetails[0].WidgetDetail.filter((m: any) => chart.chartTitle?.trim().replace(/\s+/g, '').toLowerCase() === m.widgetchartname?.trim().replace(/\s+/g, '').toLowerCase()).length;

                      //   if (this.widgetDetails[0].WidgetDetail == undefined && this.widgetDetails[0].WidgetDetail != undefined)
                      //     count = this.widgetDetails[0].WidgetDetail.filter((m: any) => chart.chartTitle?.trim().replace(/\s+/g, '').toLowerCase() === m.widgetchartname?.trim().replace(/\s+/g, '').toLowerCase()).length;
                      //   else if (this.widgetDetails[0].WidgetDetail != undefined && this.widgetDetails[0].WidgetDetail == undefined)
                      //     count = this.widgetDetails[0].WidgetDetail.filter((m: any) => chart.chartTitle?.trim().replace(/\s+/g, '').toLowerCase() === m.widgetchartname?.trim().replace(/\s+/g, '').toLowerCase()).length;
                    }
                    chart.chartSelectedNumber = count > 0 ? count : 0;
                  });
                }
              }
            }
            else {
              if (this.chunkedCharts.length > 0) {
                this.chunkedCharts[0].forEach((chart: any) => {
                  let count = 0;
                  if (this.widgetDetails.length > 0) {
                    count = 0;
                  }
                  chart.chartSelectedNumber = count > 0 ? count : 0;
                });
              }
            }
          }
        }
        else {
          if (this.chunkedCharts[0]) {
            this.chunkedCharts[0].forEach((chart: any) => {
              chart.chartSelectedNumber = 0;
            });
          }
          if (this.chunkedCharts[1]) {
            this.chunkedCharts[1].forEach((chart: any) => {
              chart.chartSelectedNumber = 0;
            });
          }
        }
      }
    }

    if ((this._configCustomService.widgetSaveObjectCustom.length != 0 && this._configCustomService.widgetSaveObjectCustom.length > 0)) {
      //this.widgetDetails = JSON.parse(localStorage.getItem('TotalwidgetDetailss') || ""); // Retrieve the JSON string from localStorage
      this.widgetDetails = this._configCustomService.widgetSaveObjectCustom;
      if (this.widgetDetails.length != undefined) {
        let snaphottypes = this.widgetDetails.find((w: any) => w.client_name == this._configService.clientName && w.snapshot_name == this.clientDetails.clientDetails.study);
        if (snaphottypes) {
          let snapshotType = snaphottypes.snapshotType.find((st: any) => st.snapshotType_name == this.selectedSnapshotType?.name);
          if (snapshotType) {
            let section = snapshotType.section.find((s: any) => s.section_name == this._configCustomService.selectedSection);
            if (section) {
              let subsection = section.subsection.find((sb: any) => sb.subsection_name == ((this._configCustomService.selectedSubsection == undefined || this._configCustomService.selectedSubsection == "") ? "NA" : this._configCustomService.selectedSubsection));
              if (subsection) {
                // widgetNames = subsection.widget_detail.map((widget: any) => widget.widget_name);
                // "widgetchart_name": "Vertical Bar Chart",
                //   "widgetParentChartType": "BarChart",
                // if (this.chunkedCharts[0]) {
                //   this.chunkedCharts[0].forEach((chart: any) => {
                //     let count = 0;
                //     if (this.widgetDetails.length > 0) {
                //       if (subsection.widget_detail != undefined)
                //         count = subsection.widget_detail.filter((m: any) => chart.chartTitle?.trim().replace(/\s+/g, '').toLowerCase() === m.widgetchart_name?.trim().replace(/\s+/g, '').toLowerCase()).length;
                //       //   else
                //       //     count = this.widgetDetails[0].WidgetDetail.filter((m: any) => chart.chartTitle?.trim().replace(/\s+/g, '').toLowerCase() === m.widgetchartname?.trim().replace(/\s+/g, '').toLowerCase()).length;

                //       //   if (this.widgetDetails[0].WidgetDetail == undefined && this.widgetDetails[0].WidgetDetail != undefined)
                //       //     count = this.widgetDetails[0].WidgetDetail.filter((m: any) => chart.chartTitle?.trim().replace(/\s+/g, '').toLowerCase() === m.widgetchartname?.trim().replace(/\s+/g, '').toLowerCase()).length;
                //       //   else if (this.widgetDetails[0].WidgetDetail != undefined && this.widgetDetails[0].WidgetDetail == undefined)
                //       //     count = this.widgetDetails[0].WidgetDetail.filter((m: any) => chart.chartTitle?.trim().replace(/\s+/g, '').toLowerCase() === m.widgetchartname?.trim().replace(/\s+/g, '').toLowerCase()).length;
                //     }
                //     chart.chartSelectedNumber = count > 0 ? count : 0;
                //   });
                // }
                // if (this.chunkedCharts[1]) {
                //   this.chunkedCharts[1].forEach((chart: any) => {
                //     let count = 0;
                //     if (this.widgetDetails.length > 0) {
                //       if (subsection.widget_detail != undefined)
                //         count = subsection.widget_detail.filter((m: any) => chart.chartTitle?.trim().replace(/\s+/g, '').toLowerCase() === m.widgetchart_name?.trim().replace(/\s+/g, '').toLowerCase()).length;
                //       //   else
                //       //     count = this.widgetDetails[0].WidgetDetail.filter((m: any) => chart.chartTitle?.trim().replace(/\s+/g, '').toLowerCase() === m.widgetchartname?.trim().replace(/\s+/g, '').toLowerCase()).length;

                //       //   if (this.widgetDetails[0].WidgetDetail == undefined && this.widgetDetails[0].WidgetDetail != undefined)
                //       //     count = this.widgetDetails[0].WidgetDetail.filter((m: any) => chart.chartTitle?.trim().replace(/\s+/g, '').toLowerCase() === m.widgetchartname?.trim().replace(/\s+/g, '').toLowerCase()).length;
                //       //   else if (this.widgetDetails[0].WidgetDetail != undefined && this.widgetDetails[0].WidgetDetail == undefined)
                //       //     count = this.widgetDetails[0].WidgetDetail.filter((m: any) => chart.chartTitle?.trim().replace(/\s+/g, '').toLowerCase() === m.widgetchartname?.trim().replace(/\s+/g, '').toLowerCase()).length;
                //     }
                //     chart.chartSelectedNumber = count > 0 ? count : 0;
                //   });
                // }
                this.availableCharts.forEach((chart: any) => {
                  let count = 0;
                  if (subsection?.widget_detail != undefined) {
                    //count = subsection.widget_detail?.filter((w: any) => w.widgetParentChartType != "LineChart").filter((m: any) => chart.displayName.trim().replace(/\s+/g, '').toLowerCase() === m.widgetParentChartType.trim().replace(/\s+/g, '').toLowerCase()).length;
                    let a = subsection.widget_detail?.filter((w: any) => w.widgetParentChartType != "LineChart").filter((m: any) => {
                      if (m.widgetParentChartType.trim().replace(/\s+/g, '').toLowerCase() == "tableview")
                        return chart.displayName.trim().replace(/\s+/g, '').toLowerCase() === "others";
                      else
                        return chart.displayName.trim().replace(/\s+/g, '').toLowerCase() === m.widgetParentChartType.trim().replace(/\s+/g, '').toLowerCase();
                    });
                    count = a.length;
                  }
                  else
                    count = subsection?.widget_detail.filter((m: any) => chart.displayName.trim().replace(/\s+/g, '').toLowerCase() === m.widgetParentChartType.trim().replace(/\s+/g, '').toLowerCase()).length;
                  chart.chartSelectedNumber = count > 0 ? count : 0;

                });
              }
              else {
                //   if (this.chunkedCharts[0]) {
                //     this.chunkedCharts[0].forEach((chart: any) => {
                //       let count = 0;
                //       if (this.widgetDetails.length > 0) {
                //         count = 0;
                //       }
                //       chart.chartSelectedNumber = count > 0 ? count : 0;
                //     });
                //   }
                //   if (this.chunkedCharts[1]) {
                //     this.chunkedCharts[1].forEach((chart: any) => {
                //       let count = 0;
                //       if (this.widgetDetails.length > 0) {
                //         if (subsection.widget_detail != undefined)
                //           count = subsection.widget_detail.filter((m: any) => chart.chartTitle?.trim().replace(/\s+/g, '').toLowerCase() === m.widgetchart_name?.trim().replace(/\s+/g, '').toLowerCase()).length;
                //         //   else
                //         //     count = this.widgetDetails[0].WidgetDetail.filter((m: any) => chart.chartTitle?.trim().replace(/\s+/g, '').toLowerCase() === m.widgetchartname?.trim().replace(/\s+/g, '').toLowerCase()).length;

                //         //   if (this.widgetDetails[0].WidgetDetail == undefined && this.widgetDetails[0].WidgetDetail != undefined)
                //         //     count = this.widgetDetails[0].WidgetDetail.filter((m: any) => chart.chartTitle?.trim().replace(/\s+/g, '').toLowerCase() === m.widgetchartname?.trim().replace(/\s+/g, '').toLowerCase()).length;
                //         //   else if (this.widgetDetails[0].WidgetDetail != undefined && this.widgetDetails[0].WidgetDetail == undefined)
                //         //     count = this.widgetDetails[0].WidgetDetail.filter((m: any) => chart.chartTitle?.trim().replace(/\s+/g, '').toLowerCase() === m.widgetchartname?.trim().replace(/\s+/g, '').toLowerCase()).length;
                //       }
                //       chart.chartSelectedNumber = count > 0 ? count : 0;
                //     });
                //   }
                // }
                this.availableCharts.forEach((chart: any) => {
                  let count = 0;
                  if (subsection?.widget_detail != undefined)
                    count = 0;
                  else
                    count = 0;
                  chart.chartSelectedNumber = count > 0 ? count : 0;

                });
              }
            }
            else {
              this.availableCharts.forEach((chart: any) => {
                chart.chartSelectedNumber = 0;
              });
              // this.chunkedCharts[0].forEach((chart: any) => {
              //   let count = 0;
              //   if (this.widgetDetails.length > 0) {
              //     count = 0;
              //   }
              //   chart.chartSelectedNumber = count > 0 ? count : 0;
              // });
            }
          }
        }
        else {
          this.availableCharts.forEach((chart: any) => {
            chart.chartSelectedNumber = 0;
          });
        }
      }
    }











    // if ((this._configService.WidgetLibSaveDataObject.length != undefined && this._configService.WidgetLibSaveDataObject.length > 0) || Object.keys(this._configService.WidgetLibSaveDataObject).length > 0) {
    //   //this.widgetDetails = JSON.parse(localStorage.getItem('TotalwidgetDetailss') || ""); // Retrieve the JSON string from localStorage
    //   // this.widgetDetails = this._configService.WidgetLibSaveDataObject;
    //   if (this.widgetDetails.length != undefined)
    //     this.widgetDetails = this.widgetDetails.filter((m: any) => m.snapshot_type == this._configService.snapshotTypeSelectedName);

    //   this.chunkedCharts[0].forEach((chart: any) => {
    //     let count = 0;
    //     if (this.widgetDetails.length == 1) {
    //       if (this.widgetDetails[0].WidgetDetail != undefined)
    //         count = this.widgetDetails[0].WidgetDetail.filter((m: any) => chart.chartTitle?.trim().replace(/\s+/g, '').toLowerCase() === m.widgetchartname?.trim().replace(/\s+/g, '').toLowerCase()).length;
    //       //   else
    //       //     count = this.widgetDetails[0].WidgetDetail.filter((m: any) => chart.chartTitle?.trim().replace(/\s+/g, '').toLowerCase() === m.widgetchartname?.trim().replace(/\s+/g, '').toLowerCase()).length;

    //       //   if (this.widgetDetails[0].WidgetDetail == undefined && this.widgetDetails[0].WidgetDetail != undefined)
    //       //     count = this.widgetDetails[0].WidgetDetail.filter((m: any) => chart.chartTitle?.trim().replace(/\s+/g, '').toLowerCase() === m.widgetchartname?.trim().replace(/\s+/g, '').toLowerCase()).length;
    //       //   else if (this.widgetDetails[0].WidgetDetail != undefined && this.widgetDetails[0].WidgetDetail == undefined)
    //       //     count = this.widgetDetails[0].WidgetDetail.filter((m: any) => chart.chartTitle?.trim().replace(/\s+/g, '').toLowerCase() === m.widgetchartname?.trim().replace(/\s+/g, '').toLowerCase()).length;
    //     }
    //     else {
    //       if (this.widgetDetails.WidgetDetail != undefined)
    //         count = this.widgetDetails.WidgetDetail.filter((m: any) => chart.chartTitle?.trim().replace(/\s+/g, '').toLowerCase() === m.widgetchartname?.trim().replace(/\s+/g, '').toLowerCase()).length;
    //       //   else if (this.widgetDetails.length > 0)
    //       //     count = this.widgetDetails.WidgetDetail.filter((m: any) => chart.chartTitle?.trim().replace(/\s+/g, '').toLowerCase() === m.widgetchartname?.trim().replace(/\s+/g, '').toLowerCase()).length;
    //       //   else if (this.widgetDetails.WidgetDetail == undefined && this.widgetDetails.WidgetDetail != undefined)
    //       //     count = this.widgetDetails.WidgetDetail.filter((m: any) => chart.chartTitle?.trim().replace(/\s+/g, '').toLowerCase() === m.widgetchartname?.trim().replace(/\s+/g, '').toLowerCase()).length;
    //       //   else if (this.widgetDetails.WidgetDetail != undefined && this.widgetDetails.WidgetDetail == undefined)
    //       //     count = this.widgetDetails.WidgetDetail.filter((m: any) => chart.chartTitle?.trim().replace(/\s+/g, '').toLowerCase() === m.widgetchartname?.trim().replace(/\s+/g, '').toLowerCase()).length;
    //     }
    //     chart.chartSelectedNumber = count > 0 ? count : 0;
    //   });


    // }
    if (this._configCustomService.widgetSaveObjectCustom.length > 0) {
      if (this.widgetList != undefined && this.widgetList != null && this.previousSection != this.selectedSection) {
        this.widgetList =this._configCustomService.getVisualSelectWidgetDetails(
  this._configCustomService.widgetSaveObjectCustom[0],
  this._configCustomService.selectedSection,
  (this._configCustomService.selectedSubsection == undefined || this._configCustomService.selectedSubsection == "") ? "NA" : this._configCustomService.selectedSubsection,
  this.selectedSnapshotType?.name,
  this._configService.audienceCohortType
)
        if (this.widgetList.length > 0) {
          this.BindCustomMetricSoftDelete();
        }
        this.prevWidgetList = this.widgetList;
      } else {
        this.widgetList = this.prevWidgetList
      }

    }

    this.availableCharts = this.availableCharts;
    this.cdr.detectChanges();
  }

  SaveClicked() {
    this._loaderService.showLoader();



    if (this._configCustomService.layoutSubmitFlag == 1) { //this condition means layout submit has been clicked
      //creating data based on what clicked in layout.
      // this._configCustomService.layoutSubmitFlag = 0;
      let temp = (() => { try { return JSON.parse(this._configService.objectFromSnapshotLayout); } catch { return []; } })();
      // let temp = JSON.parse(this._configService.objectFromSnapshotLayout);
      let arr = [];
      for (let i = 0; i < temp.length; i++) {
        if (temp[i].selectedLayout != null) {
          arr.push({
            key: temp[i].page,
            value: temp[i].selectedLayout
          })
        }
      }

      //updating save object based on layout submit
      var x = this._configCustomService.widgetSaveObjectCustom[0].snapshotType;

      for (let i = 0; i < x.length; i++) {
        if (x[i].snapshotType_name === this._configCustomService.selectedSnapshotType.name) {
          for (let j = 0; j < x[i].section.length; j++) {
            if (x[i].section[j].section_name === this._configCustomService.selectedSection) {
              for (let k = 0; k < x[i].section[j].subsection.length; k++) {
                if (x[i].section[j].subsection[k].subsection_name ===
                  ((this._configCustomService.selectedSubsection == undefined || this._configCustomService.selectedSubsection == "") ? "NA" : this._configCustomService.selectedSubsection)) {
                  x[i].section[j].subsection[k].page_details = arr
                }
              }
            }
          }
        }
      }

      for (let i = 0; i < x.length; i++) {
        if (x[i].snapshotType_name === this._configCustomService.selectedSnapshotType.name) {
          for (let j = 0; j < x[i].section.length; j++) {
            if (x[i].section[j].section_name === this._configCustomService.selectedSection) {
              for (let k = 0; k < x[i].section[j].subsection.length; k++) {
                if (x[i].section[j].subsection[k].subsection_name ===
                  ((this._configCustomService.selectedSubsection == undefined || this._configCustomService.selectedSubsection == "") ? "NA" : this._configCustomService.selectedSubsection)) {
                  for (let z = 0; z < x[i].section[j].subsection[k].widget_detail.length; z++) {
                    x[i].section[j].subsection[k].widget_detail[z].previewChartPostion = 0;
                  }
                }
              }
            }
          }
        }
      }
      this._configCustomService.widgetSaveObjectCustom[0].snapshotType = x;

    }


    //-------------Adding layout Popup -------------------------------

    //Making enabling of preview is pageDetail from layout is available
    var y = this._configCustomService.widgetSaveObjectCustom[0].snapshotType;

    for (let i = 0; i < y.length; i++) {
      if (y[i].snapshotType_name === this._configCustomService.selectedSnapshotType.name) {
        for (let j = 0; j < y[i].section.length; j++) {
          if (y[i].section[j].section_name === this._configCustomService.selectedSection) {
            for (let k = 0; k < y[i].section[j].subsection.length; k++) {
              if (y[i].section[j].subsection[k].subsection_name ===
                ((this._configCustomService.selectedSubsection == undefined || this._configCustomService.selectedSubsection == "") ? "NA" : this._configCustomService.selectedSubsection)) {
                if (y[i].section[j].subsection[k].page_details.length > 0) {
                  let count = 0
                  for (let m = 0; m < y[i].section[j].subsection[k].page_details.length; m++) {
                    count = count + y[i].section[j].subsection[k].page_details[m].value;
                  }
                  if (count >= this.widgetList.length) {
                    //this.showPreview = true;
                  }
                  else {
                    this.showErrorPopUp = true;
                    this.popUpMessage = "Please configure Layout first";
                    this.errorheaderTitle = "Info";
                    this._loaderService.hideLoader();
                    this.cdRef.detectChanges();
                    this.showPreview = false;
                    return;
                  }
                }
                else {
                  this.showErrorPopUp = true;
                  this.popUpMessage = "Please configure Layout first";
                  this.errorheaderTitle = "Info";
                  this._loaderService.hideLoader();
                  this.cdRef.detectChanges();
                  this.showPreview = false;
                  return;
                }
              }
            }
          }
        }
      }
    }
    // this._configCustomService.widgetSaveObjectCustom[0].snapshotType = x;

    //-----------------------------------------------------------------

    this.showErrorPopUp = false;
    // this.errorheaderTitle = "Info";
    // this.popUpMessage = "Saved Successfully.";
    this._configCustomService.saveCustomSnapshotWidgetLibrary(this._configCustomService.widgetSaveObjectCustom[0]).subscribe(
      (response: any) => {

        // response = JSON.parse(response.result);
        if (response.Data == 'Document updated successfully') {
          // Handle success here
          this._loaderService.hideLoader();
          this.showErrorPopUp = true;
          this.popUpMessage = "Saved Successfully.";
          this.errorheaderTitle = "Info";
          this.cdRef.detectChanges();


          // this.fromSave = true;

        }
        else if (response.Data == 'Document inserted successfully') {
          this._loaderService.hideLoader();
          this.showErrorPopUp = true;
          this.popUpMessage = "Saved Successfully.";
          this.errorheaderTitle = "Info";
          this.cdRef.detectChanges();
          // this.fromSave = true;

        }
        else {
          // Handle any non-200 response codes
          this._loaderService.hideLoader();
          this.showErrorPopUp = true;
          this.popUpMessage = "Some Error Occured";
          this.errorheaderTitle = "Info";

          this.cdRef.detectChanges();

          // this.fromSave = false;
        }

        //Making enabling of preview is pageDetail from layout is available
        var x = this._configCustomService.widgetSaveObjectCustom[0].snapshotType;

        for (let i = 0; i < x.length; i++) {
          if (x[i].snapshotType_name === this._configCustomService.selectedSnapshotType.name) {
            for (let j = 0; j < x[i].section.length; j++) {
              if (x[i].section[j].section_name === this._configCustomService.selectedSection) {
                for (let k = 0; k < x[i].section[j].subsection.length; k++) {
                  if (x[i].section[j].subsection[k].subsection_name ===
                    ((this._configCustomService.selectedSubsection == undefined || this._configCustomService.selectedSubsection == "") ? "NA" : this._configCustomService.selectedSubsection)) {
                    if (x[i].section[j].subsection[k].page_details.length > 0) {
                      let count = 0
                      for (let m = 0; m < x[i].section[j].subsection[k].page_details.length; m++) {
                        count = count + x[i].section[j].subsection[k].page_details[m].value;
                      }
                      if (count >= this.widgetList.length) {
                        this.showPreview = true;
                      }
                      else {
                        this.showPreview = false;
                      }
                    }
                    else {
                      this.showPreview = false;
                    }
                  }
                }
              }
            }
          }
        }
        this._configCustomService.widgetSaveObjectCustom[0].snapshotType = x;
      }
    );

    //   if (data.body.Data == '"Saved Successfully"') {

    //     this.popUpMessage = 'Saved Successfully';
    //     this.errorheaderTitle = 'Success';
    //   }
    //   else {
    //     //this.showErrorPopUp = true;
    //     this.popUpMessage = 'Failed to Submit' + data.body.Data;
    //     this.errorheaderTitle = 'Error';
    //   }
    //   this._loaderService.hideLoader();
    // });
  }



  CheckCountForPreviewEnable() {
    let dataObject = this._configService.clientSnapshotSelectedData;
    let number_of_widgets = dataObject == undefined || dataObject.number_of_widgets == undefined ? 0 : dataObject.number_of_widgets;
    const checkedIcons = document.getElementsByClassName('widget_visualization');

    if ((checkedIcons.length - 1) == number_of_widgets) {
      const previewButton = document.querySelector('.preview-button') as HTMLElement;
      if (this.widgetList.length > 0) {
        previewButton.classList.remove('disabled');
      }
      const chartBtnContainers = document.querySelectorAll('.chart-btn-conatiner-tiles') as NodeListOf<HTMLElement>;
      chartBtnContainers.forEach(container => {
        container.classList.add('disabled');
      });
    }
  }

  onCloseIconClick(closePopUp: string): void {
    if (closePopUp == 'false') {
      this.showErrorPopUp = false;
      if (this.isDeleteSubsection || this.isDeleteSection) {
        if (this.isDeleteSubsection) {
          this.selectedSubSection = ""; this._configCustomService.selectedSubsection = "";
        }
        this._configCustomService.widgetSaveObjectCustom = [];
        this.initialCall();
        // this.subsectionList=this.subsectionList.filter((ss:any)=>ss.name!=subsectionobj.name);
        this.cdRef.detectChanges();

        setTimeout(() => {
          this._loaderService.hideLoader();
        }, 4000)

      }
      if (!this.isMetricConfigured) {
        this._configService.fromBackButton = false;
        this._configCustomService.fromBackButton = false;
        const dataToSend = { clientDetails: this.clientDetails, enableWidgetLibrary: true, widgetObject: this._configService.ChartCustomSaveDataObject, fromBack: true, dontshowWidgetLibrary: true };
        this._configCustomService.recievedStatusDataOnBackButtonClick = dataToSend;
        this.routerObj.navigateByUrl('/Snapshot', { skipLocationChange: true }).then(() => {
          this.routerObj.navigate(['/Snapshot/configuaration'], { state: { data: dataToSend } });
        });
      }
    }
  }

  onSubsectionPopupCloseIconClick(status: any): void {
    this.showSubsectionPopup = false;
    this.errorheaderTitle = "";
    if (status.isValidated && status.subsectionName != "") {
      const itemExists = this.subsectionList.some(
        (item: any) => item.name === status.subsectionName
      );
      if (!itemExists) {
        this.subsectionList.forEach((ss: any) => { ss.selected = false })
        this.subsectionList.push({
          name: status.subsectionName,
          value: status.subsectionName,
          selected: true
        });
        this._configCustomService.subsectionlist = this.subsectionList;
        this.subSectionHeader = status.subsectionName;
        this.selectedSubSection = status.subsectionName;
        this._configCustomService.selectedSubsection = this.selectedSubSection;
        const chartSelectionContainer = document.querySelector('.chart-selection-container');
        if (chartSelectionContainer && this.selectedSection != '' && this.selectedSubSection != "") {
          chartSelectionContainer.classList.remove('disabled');
          this._configCustomService.isAdditionalConfig = true;
        }
      }
      else {
        this.showErrorPopUp = true;
        this.popUpMessage = "Name already exists..!"
        this.errorheaderTitle = "Info";
        return;
      }
      if (this.subsectionList.length > 1) {
        // Only push if the item doesn't already exist
        if (this._configCustomService.selectedSnapshotType) {
          this.updateChartSelectedNumber();
        }
      }
      else {
        if ((this._configCustomService.widgetSaveObjectCustom.length != 0 && this._configCustomService.widgetSaveObjectCustom.length > 0)) {
          //this.widgetDetails = JSON.parse(localStorage.getItem('TotalwidgetDetailss') || ""); // Retrieve the JSON string from localStorage
          this.widgetDetails = this._configCustomService.widgetSaveObjectCustom;
          if (this.widgetDetails.length != undefined) {
            let snaphottypes = this.widgetDetails.find((w: any) => w.client_name == this._configService.clientName && w.snapshot_name == this.clientDetails.clientDetails.study);
            if (snaphottypes) {
              let snapshotType = snaphottypes.snapshotType.find((st: any) => st.snapshotType_name == this._configCustomService.selectedSnapshotType.name);
              if (snapshotType) {
                let section = snapshotType.section.find((s: any) => s.section_name == this._configCustomService.selectedSection);
                if (section) {
                  let subsection = section.subsection.find((sb: any) => sb.subsection_name == "NA");
                  if (subsection) {
                    subsection.subsection_name = status.subsectionName;
                  }
                }
              }
            }
          }
        }
      }

    }
    if (this.widgetList.length == 0) {
      this.showPreview = false;
    }
  }


  section_Blur: boolean = false;
  onSectionInputBlur(): void {
    this.section_Blur = true;
    this.sectionInputFocused = false;
  }

  onSectionFocus(event: Event): void {
    this.sectionInputFocused = true;
  }

  // sectionList: any[] = ["Dummy", "Dummy Value", "Even More Dummy Value", "boolean", "HTMLInputElement Value", "Even More target Value"];
  sectionList: any = []
  invalidCharactersPattern = /[\/\\*?"<>|]/;
  previousSection = "";
  onSectionChange(event: Event, isInputChange: boolean): void {
    event?.stopPropagation();
    this.sectionList = this._configCustomService.sectionList;
    this.sectionDropdownPopup = true;
    this.typeDropdownPopup = false;
    this.subSectionDropdownPopup = false;
    // this.previousSection = this.selectedSection;
    const input = event.target as HTMLInputElement;
    const chartSelectionContainer = document.querySelector('.chart-selection-container');
    // if (this.selectedSection !== input?.value) {
    if (input != null && input?.value != null) {
      if (this.invalidCharactersPattern.test(input.value)) {
        // Prevent the input if it contains invalid characters
        let eventItem: any = event.target
        eventItem.value = input.value.replace(this.invalidCharactersPattern, '');
        this.selectedSection = eventItem.value;
        // this.subSectionHeader=eventItem.value;
      }
      else {
        this.selectedSection = input.value;
      }
      let sec = this.sectionList.find((s: any) => s.name == input?.value);
      if (!sec) {
        this.selectedSubSection = "";
        this.subSectionHeader = "Sub Section";
        this.selectedSubSection = "";
        this._configCustomService.selectedSubsection = "";
      }
      else {
        chartSelectionContainer?.classList.add('disabled');
        this._configCustomService.isAdditionalConfig = false;
      }
    }
    if (input?.value == "") {
      this.selectedSubSection = "";
      this.subSectionHeader = "Sub Section";
      chartSelectionContainer?.classList.add('disabled');
      this._configCustomService.isAdditionalConfig = false;
      this.separateFomExists = false;
    }
    this._configCustomService.selectedSection = this.selectedSection;
    this.getUniqueSubsectionList();
    this.GetThisSnapshotTypeData();
    if (this.sectionList.length == 0 && input?.value != "") {
      chartSelectionContainer?.classList.remove('disabled');
      this._configCustomService.isAdditionalConfig = true;
    }
    if (this.subsectionList.length == 0 && input?.value != "") {
      chartSelectionContainer?.classList.remove('disabled');
      this._configCustomService.isAdditionalConfig = true;
    }
    const subsectionBlock = document.querySelector('.widget-items.subsection-block');
    // if (this.selectedSection != "" || undefined && input != null || "") {
    if (this.selectedSection != "" && input != null || "") {
      if (subsectionBlock) {
        subsectionBlock.classList.remove('disabled');
      }
    }
    else {
      if (subsectionBlock) {
        this._configCustomService.selectedSubsection = undefined;
        this.subSectionDropdownPopup = false;
        subsectionBlock.classList.add('disabled');
      }
    }

    if (this.previousSection !== this.selectedSection) {
      if (chartSelectionContainer && this.selectedSection != '') {
        let ss = this.subsectionList.filter((ss: any) => ss.name != "NA");
        if (ss.length == 0) {
          chartSelectionContainer.classList.remove('disabled');
          this._configCustomService.isAdditionalConfig = true;
        }
        else {
          chartSelectionContainer.classList.add('disabled');
          this._configCustomService.isAdditionalConfig = false;
        }
      }
      else {
        chartSelectionContainer?.classList.add('disabled');
        this._configCustomService.isAdditionalConfig = false;
        this.selectedSubSection = "";
        this.subSectionHeader = "Sub Section"
        this.subsectionList.forEach((ss: any) => { ss.selected = false })

      }
    }
    else {
      this.subsectionList.forEach((ss: any) => {
        if (ss.name == this.selectedSubSection) {
          ss.selected = true
          chartSelectionContainer?.classList.remove('disabled');
          this._configCustomService.isAdditionalConfig = true;
        }
      })
      if (this.subsectionList.length == 0 && input?.value != "") {
        chartSelectionContainer?.classList.remove('disabled');
        this._configCustomService.isAdditionalConfig = true;
      }
    }

    if (this._configCustomService.selectedSnapshotType) {
      this.updateChartSelectedNumber();
      this.getCallToEnablePreview(this._configCustomService.widgetSaveObjectCustom);
    }

  // While typing keep focus state; clear icon uses binding on focus + value
  // Icon appears only when unfocused; no confirmation tracking needed now

    this.cdRef.detectChanges();
    // }
  }

  BindCustomMetricSoftDelete() {
    let customMetrics: any[] = [];
    if (this._configCustomService?.widgetAllCustomMetrics) {
      customMetrics = JSON.parse(JSON.stringify(this._configCustomService?.widgetAllCustomMetrics));
    }
    let widgetDetails = JSON.parse(JSON.stringify(this._configCustomService.widgetSaveObjectCustom));

    // if( customMetrics != undefined && customMetrics !=null && customMetrics.length > 0 ){
    //   customMetrics = customMetrics.filter((metric : any) => metric.soft_delete == "1");

    //   let widgetContainSoftDeleteMetrics : any[] = [];
    //   if(widgetDetails.length > 0 ){
    //     widgetDetails.forEach((widget:any) => {
    //       widget.snapshotType.forEach((snapshots:any) => {
    //         snapshots.section.forEach((sec : any) => {
    //           sec.subsection.forEach((subSec : any) => {
    //             subSec.widget_detail.forEach((wid:any) => {
    //               wid.metric.forEach((metric :any) =>{
    //                 metric.metric_value.forEach((metricValue : any) => {
    //                   let metrics = JSON.parse(metricValue);
    //                   let prevCount = metrics.length;
    //                   //metrics = metrics.filter( (it:any) => !customMetrics.some((remove:any) =>  remove.selection_name == it.option));

    //                   metrics?.forEach((mt : any) => {
    //                     let data = customMetrics?.filter((remove:any) =>  remove.selection_name == mt.option);
    //                     if(data.length > 0 ){
    //                       widgetContainSoftDeleteMetrics.push({
    //                         widgetName :wid.widget_name,
    //                         metric : mt.option
    //                       })
    //                     }
    //                   })                      
    //                 })
    //               })
    //             })
    //           })
    //         })
    //       })
    //     })
    //   }


    //   if(widgetContainSoftDeleteMetrics.length > 0 && this.widgetList != undefined && this.widgetList != null){
    //     let isSoftDeleteAvailable = false
    //     this.widgetList = this.widgetList.map((widget:any) => {
    //       let wid = widgetContainSoftDeleteMetrics.filter((m:any) => m.widgetName == widget.widgetName);
    //       if(wid.length > 0){
    //         widget.isSoftDelete = true;
    //         isSoftDeleteAvailable = true;
    //       }else{
    //         widget.isSoftDelete = false;
    //       }

    //       return widget;
    //     })

    //     if(isSoftDeleteAvailable){
    //       let message =  "If this metric was configured in any existing widget, please update the metric in the Widget Library. Affected widgets will be highlighted in Red Border for easy identification."
    //       this.showMessagePopup(message);
    //     }
    //   }

    //   if(customMetrics.length > 0){
    //     let UpdatecustomMetrics = JSON.parse(JSON.stringify(this._configCustomService.widgetCustomMetrics));
    //     let isSoftDeleteAvailable = false;
    //     UpdatecustomMetrics = UpdatecustomMetrics?.map((metric:any) => {
    //       if( metric.soft_delete == "1"){
    //         let isDataAvailable = widgetContainSoftDeleteMetrics.filter((m:any) => m.metric == metric.selection_name);
    //         if(isDataAvailable.length == 0 ){
    //           metric.soft_delete = "2";
    //           //isSoftDeleteAvailable = true;
    //         } 
    //       }
    //       return metric;
    //     });

    //     if(isSoftDeleteAvailable){
    //       this._configCustomService.updateCustomMetricSnapShotWidgetLibrary(UpdatecustomMetrics).subscribe(
    //         (response: any) => {
    //           if (response.Data != "") {

    //           }
    //           else {
    //           }
    //         }
    //       );
    //     }
    //   }
    // }

    if (this.widgetDetails.length != null && this.widgetDetails.length != undefined) {
      customMetrics = customMetrics.filter((metric: any) => metric.soft_delete == "1");
      let widgetContainSoftDeleteMetrics: any[] = [];
      let snaphottypes = this.widgetDetails.find((w: any) => w.client_name == this._configService.clientName && w.snapshot_name == this.clientDetails.clientDetails.study);
      if (snaphottypes) {
        let snapshotType = snaphottypes.snapshotType.find((st: any) => st.snapshotType_name == this._configCustomService.selectedSnapshotType.name);
        if (snapshotType) {
          let section = snapshotType.section.find((s: any) => s.section_name == this._configCustomService.selectedSection);
          if (section) {
            let subsection = section.subsection.find((sb: any) => sb.subsection_name == ((this._configCustomService.selectedSubsection == undefined || this._configCustomService.selectedSubsection == "") ? "NA" : this._configCustomService.selectedSubsection));
            if (subsection) {
              subsection.widget_detail.forEach((wid: any) => {
                // Check metrics
                if (wid.metric) {
                  wid.metric.forEach((metric: any) => {
                    metric.metric_value.forEach((metricValue: any) => {
                      let metrics = JSON.parse(metricValue);
                      metrics?.forEach((mt: any) => {
                        let data = customMetrics?.filter((remove: any) => remove.selection_name == mt.option);
                        if (data.length > 0) {
                          widgetContainSoftDeleteMetrics.push({
                            widgetName: wid.widget_name,
                            metric: mt.option
                          })
                        }
                      })
                    })
                  })
                }
                
                // Check audience
                if (wid.audience) {
                  wid.audience.forEach((aud: any) => {
                    // Check audience option
                    if (aud.option) {
                      let data = customMetrics?.filter((remove: any) => remove.selection_name == aud.option);
                      if (data.length > 0) {
                        widgetContainSoftDeleteMetrics.push({
                          widgetName: wid.widget_name,
                          metric: aud.option
                        })
                      }
                    }
                    // Check audience data if it exists
                    if (aud.data && aud.data.response_label) {
                      let audienceData = customMetrics?.filter((remove: any) => remove.selection_name == aud.data.response_label);
                      if (audienceData.length > 0) {
                        widgetContainSoftDeleteMetrics.push({
                          widgetName: wid.widget_name,
                          metric: aud.data.response_label
                        })
                      }
                    }
                  })
                }
                
                // Check brand
                if (wid.brand) {
                  wid.brand.forEach((br: any) => {
                    // Check brand option
                    if (br.option) {
                      let data = customMetrics?.filter((remove: any) => remove.selection_name == br.option);
                      if (data.length > 0) {
                        widgetContainSoftDeleteMetrics.push({
                          widgetName: wid.widget_name,
                          metric: br.option
                        })
                      }
                    }
                    // Check brand data if it exists
                    if (br.data && br.data.response_label) {
                      let brandData = customMetrics?.filter((remove: any) => remove.selection_name == br.data.response_label);
                      if (brandData.length > 0) {
                        widgetContainSoftDeleteMetrics.push({
                          widgetName: wid.widget_name,
                          metric: br.data.response_label
                        })
                      }
                    }
                  })
                }
              })
            }
          }
        }
      }

      if (widgetContainSoftDeleteMetrics.length > 0 && this.widgetList != undefined && this.widgetList != null) {
        let isSoftDeleteAvailable = false
        this.widgetList = this.widgetList.map((widget: any) => {
          let wid = widgetContainSoftDeleteMetrics.filter((m: any) => m.widgetName == widget.widgetName);
          if (wid.length > 0) {
            widget.isSoftDelete = true;
            isSoftDeleteAvailable = true;
          } else {
            widget.isSoftDelete = false;
          }

          return widget;
        })

        if (isSoftDeleteAvailable) {
          let message = "If this metric was configured in any existing widget, please update the metric in the Widget Library. Affected widgets will be highlighted in Red Border for easy identification."
          this.showMessagePopup(message);
        }
      }

      // if(customMetrics.length > 0){
      //   let UpdatecustomMetrics = JSON.parse(JSON.stringify(this._configCustomService.widgetAllCustomMetrics));
      //   let isSoftDeleteAvailable = false;
      //   UpdatecustomMetrics = UpdatecustomMetrics?.map((metric:any) => {
      //     if( metric.soft_delete == "1"){
      //       let isDataAvailable = widgetContainSoftDeleteMetrics.filter((m:any) => m.metric == metric.selection_name);
      //       if(isDataAvailable.length == 0 ){
      //         metric.soft_delete = "2";
      //         isSoftDeleteAvailable = true;
      //       } 
      //     }
      //     return metric;
      //   });

      //   if(isSoftDeleteAvailable){
      //     this._configCustomService.updateCustomMetricSnapShotWidgetLibrary(UpdatecustomMetrics).subscribe(
      //       (response: any) => {

      //         if (response.Data != "") {

      //         }
      //         else {
      //         }
      //       }
      //     );
      //   }
      // }
    }

    this.cdRef.detectChanges();
  }

  // showMessagePopup(message:string="Are you show", headerTxt:string = "Information") : void {
  //   const alertObj: AlertMessageModel = {
  //     header: headerTxt,
  //     message: message,
  //     show: true,
  //   };
  //   this._alertService.showAlert(alertObj);
  // }

  fun() {
    return !this.showPreview;
  }
  onSectionInputChange(value: string) {
    if (this.widgetList.length == 0) {
      this.showPreview = false;
    }
    // Additional logic can be added here
  }

  onSectionDropdownClick(studyName: any) {
    const chartSelectionContainer = document.querySelector('.chart-selection-container');
    this.sectionList.forEach((ss: any) => {
      if (ss.name == studyName.name) {
        ss.selected = true;
      }
      else {
        ss.selected = false;
      }
    })
    this.previousSection = this.selectedSection;
    this.selectedSection = studyName.name;
    this._configCustomService.selectedSection = this.selectedSection;
    this.getUniqueSubsectionList();
    if (this.subsectionList.length == 0) {
      chartSelectionContainer?.classList.remove('disabled');
      this._configCustomService.isAdditionalConfig = true;

      // check if separate fom exists for this section.
      this._configService.checkSeparateFomExists({
        client_name: this.clientDetails.clientDetails.client_name,
        study_name: this.clientDetails.clientDetails.selectedStudy,
        snapshot_name: this.clientDetails.clientDetails.study,
        snapshot_type: this._configCustomService.selectedSnapshotType?.name ?? this.selectedSnapshotType?.name ?? '',
        section_name: this.selectedSection ?? '',
        subsection_name: this.selectedSubSection == "NA" ? '' : this.selectedSubSection ?? '',
      }).subscribe((response: any) => {
        this.separateFomExists = response?.exists;
        this.cdRef.detectChanges();
      });
    }
    else {
      chartSelectionContainer?.classList.add('disabled');
      this._configCustomService.isAdditionalConfig = false;
    }
    if (this.previousSection == this.selectedSection) {
      this.subsectionList.forEach((ss: any) => {
        if (ss.name == this.selectedSubSection) {
          ss.selected = true;
        }
      })
    }
    this.sectionDropdownPopup = false;
    const subsectionBlock = document.querySelector('.widget-items.subsection-block');
    if (this.selectedSection != "" || undefined) {
      if (subsectionBlock) {
        subsectionBlock.classList.remove('disabled');
      }
    }
    else {
      if (subsectionBlock) {
        this._configCustomService.selectedSubsection = undefined;
        this.subSectionDropdownPopup = false;
        subsectionBlock.classList.add('disabled');
      }
    }
    if (this._configCustomService.selectedSnapshotType) {
      this.updateChartSelectedNumber();
      this.getCallToEnablePreview(this._configCustomService.widgetSaveObjectCustom);
    }
  }



  deleteSubsection(subsectionobj: any) {
    // this.subsectionList.splice(this.subsectionList.indexOf(event), 1);
    // this.subsectionList.foreach((ss: any) => { ss.selected = false; })
    // this.selectedSubSection = "";
    let data = {
      ClientName: this.clientDetails.clientDetails.client_name,
      StudyName: this.clientDetails.clientDetails.selectedStudy,
      SnapshotName: this.clientDetails.clientDetails.study,
      SnapshotTypeName: this.selectedSnapshotType?.name,
      SectionName: this.selectedSection,
      SubsectionName: subsectionobj.name,
      WidgetName: "",
      Type: "subsection"
    }
    this._configCustomService.deleteCustomSnapshotSectionSubsectionLevel(data).subscribe((r1: any) => {

      let data = r1?.Data
      if (r1?.Data == "Section, Subsection, or Widget detail deleted successfully") {
        this.isDeleteSubsection = true;
        this.isDeleteSection = false;
        this.showErrorPopUp = true;
        this.popUpMessage = "Deleted Successfully..!";
        this.errorheaderTitle = "Info";
        if (this.subsectionList.length <= 1) {
          this.selectedSubSection = undefined;
          this._configCustomService.selectedSubsection = undefined;
          this.subSectionHeader = "Sub Section"
        }
        else {
          let m = this.subsectionList.filter((ss: any) => ss.name != subsectionobj.name);
          this.selectedSubSection = m[0].name;
          this.subSectionHeader = m[0].name
        }
        if (this._configCustomService.recievedStatusDataOnBackButtonClick) this._configCustomService.recievedStatusDataOnBackButtonClick.fromBack = false;
        this.cdRef.detectChanges();
      }
      else {
        if (r1?.Data == "No matching document found.") {
          // this.showErrorPopUp = true;
          // this.popUpMessage = "Please save the Configuration..!";
          // this.errorheaderTitle = "Info";
          if (this.subsectionList.length <= 1) {
            this.selectedSubSection = undefined;
            this._configCustomService.selectedSubsection = undefined;
            this.subSectionHeader = "Sub Section"
          }
          else {
            let m = this.subsectionList.filter((ss: any) => ss.name != this.selectedSubSection);
            this.selectedSubSection = m[0].name;
            this.subSectionHeader = m[0].name
          }
          this.subsectionList = this.subsectionList.filter((ss: any) => ss.name != this.selectedSubSection);
          this.isDeleteSubsection = true;
          this.showErrorPopUp = true;
          this.popUpMessage = "Deleted Successfully..!";
          if ((this._configCustomService.widgetSaveObjectCustom.length != 0 && this._configCustomService.widgetSaveObjectCustom.length > 0)) {
            //this.widgetDetails = JSON.parse(localStorage.getItem('TotalwidgetDetailss') || ""); // Retrieve the JSON string from localStorage
            this.widgetDetails = this._configCustomService.widgetSaveObjectCustom;
            if (this.widgetDetails.length != undefined) {
              let snaphottypes = this.widgetDetails.find((w: any) => w.client_name == this._configService.clientName && w.snapshot_name == this.clientDetails.clientDetails.study);
              if (snaphottypes) {
                let snapshotType = snaphottypes.snapshotType.find((st: any) => st.snapshotType_name == this._configCustomService.selectedSnapshotType.name);
                if (snapshotType) {
                  let section = snapshotType.section.find((s: any) => s.section_name == this._configCustomService.selectedSection);
                  if (section) {
                    section.subsection = section.subsection.filter(
                      (sb: any) => sb.subsection_name !== subsectionobj.name
                    );
                  }
                }
              }
            }
          };
          this.updateChartSelectedNumber();
          // this.getUniqueSubsectionList();
          this.cdRef.detectChanges();
        }
      }
    })
  }

  deleteSection(sectionobj: any) {
    // this.subsectionList.splice(this.subsectionList.indexOf(event), 1);
    // this.subsectionList.foreach((ss: any) => { ss.selected = false; })
    // this.selectedSubSection = "";
    const subsectionBlock = document.querySelector('.widget-items.subsection-block');
    const chartSelectionContainer = document.querySelector('.chart-selection-container');
    let data = {
      ClientName: this.clientDetails.clientDetails.client_name,
      StudyName: this.clientDetails.clientDetails.selectedStudy,
      SnapshotName: this.clientDetails.clientDetails.study,
      SnapshotTypeName: this.selectedSnapshotType?.name,
      SectionName: sectionobj.name,
      SubsectionName: "",
      WidgetName: "",
      Type: "section"
    }
    this._configCustomService.deleteCustomSnapshotSectionSubsectionLevel(data).subscribe((r1: any) => {

      let data = r1?.Data
      if (r1?.Data == "Section, Subsection, or Widget detail deleted successfully") {
        this.isDeleteSubsection = false;
        this.isDeleteSection = true;
        this.showErrorPopUp = true;
        this.popUpMessage = "Deleted Successfully..!";
        this.errorheaderTitle = "Info";
        if (this.sectionList.length <= 1) {
          this.selectedSection = "";
          this._configCustomService.selectedSection = "";
          this.subsectionList = []
          this.subSectionHeader = "Sub Section"
          this.selectedSubSection = "";
          this._configCustomService.selectedSubsection = "";
          subsectionBlock?.classList.add("disabled");
          chartSelectionContainer?.classList.add("disabled");
          this._configCustomService.isAdditionalConfig = false;
        }
        else {
          let m = this.sectionList.filter((ss: any) => ss.name != sectionobj.name);
          this.selectedSection = m[0].name;
          this.subSectionHeader = "Sub Section";
          this.selectedSubSection = "";
          this._configCustomService.selectedSubsection = "";
        }
        this.sectionList = [];
        this.cdRef.detectChanges();
        if (this._configCustomService.recievedStatusDataOnBackButtonClick) this._configCustomService.recievedStatusDataOnBackButtonClick.fromBack = false
      }
      else {
        if (r1?.Data == "No matching document found.") {
          this.showErrorPopUp = true;
          this.popUpMessage = "Some Error Occured..!";
          this.errorheaderTitle = "Info";

          this.cdRef.detectChanges();
        }
      }
    })
  }

  subsectionList: any = [];
  // subsectionList: any =
  //   [
  //     { "selected": false, "value": "Dummy", "name": "Dummy" },
  //     // { "selected": false, "value": "Dummy Value", "name": "Dummy Value" },
  //     // { "selected": false, "value": "Even More Dummy Value", "name": "Even More Dummy Value" },
  //     // { "selected": false, "value": "boolean", "name": "boolean" },
  //     // { "selected": false, "value": "HTMLInputElement Value", "name": "HTMLInputElement Value" },
  //     // { "selected": false, "value": "Even More target Value", "name": "Even More target Value" }
  //   ]

  onSubSectionChange(event: any): void {
    this.subsectionList.forEach((ss: any) => {
      if (ss == event) {
        ss.selected = true;
        this.selectedSubSection = ss.name;
        this.subSectionHeader = ss.name;
      }
      else {
        ss.selected = false;
      }
    })
    this._configCustomService.selectedSubsection = this.selectedSubSection;
    const chartSelectionContainer = document.querySelector('.chart-selection-container');
    if (chartSelectionContainer && this.selectedSection != '' && this.selectedSubSection != "") {
      chartSelectionContainer.classList.remove('disabled');
      this._configCustomService.isAdditionalConfig = true;
    }
    if (this._configCustomService.selectedSection && this._configCustomService.selectedSnapshotType) {
      this.updateChartSelectedNumber();
      this.getCallToEnablePreview(this._configCustomService.widgetSaveObjectCustom);
    }
    this.cdRef.detectChanges();
    // check if separate fom exists for this section.
    this._configService.checkSeparateFomExists({
      client_name: this.clientDetails.clientDetails.client_name,
      study_name: this.clientDetails.clientDetails.selectedStudy,
      snapshot_name: this.clientDetails.clientDetails.study,
      snapshot_type: this._configCustomService.selectedSnapshotType?.name ?? this.selectedSnapshotType?.name ?? '',
      section_name: this.selectedSection ?? '',
      subsection_name: this.selectedSubSection == "NA" ? '' : this.selectedSubSection ?? '',
    }).subscribe((response: any) => {
      this.separateFomExists = response?.exists;
      this.cdRef.detectChanges();
    });
  }
  showSubsectionPopup: any = false;
  addSubsection() {
    this.showSubsectionPopup = true;
    this.errorheaderTitle = 'Subsection'
  }




  onSubSectionDropdownClick(event: any) {
    // this.selectedSubSection = studyName;
    // this.subSectionDropdownPopup = false;
    this.subSectionDropdownPopup = !this.subSectionDropdownPopup;
    this.typeDropdownPopup = false;
    this.sectionDropdownPopup = false;
    event.stopPropagation();
  }

  @HostListener('document:click', ['$event'])
  onDocumentClick(event: Event): void {
    if (this.section_Blur) {
      if (!this.isClickInside(event, '.section-block')) {
        this.sectionList = [];
        this.section_Blur = false;
      }
    }
  }

  private isClickInside(event: Event, className: string): boolean {
    const elements = document.querySelectorAll(className);
    for (let i = 0; i < elements.length; i++) {
      const container = elements[i];
      if (container.contains(event.target as Node)) {
        return true;
      }
    }
    return false;
  }

  //---------------------------- New Code for Layout and preview ------------------------
  layoutPopup: boolean = false;
  showPreview: boolean = false;
  datatoPreview: any;
  objectFromLayout: string = "";
  LayoutClicked() {
    this.layoutPopup = true;

    //binding get data for Layout
    // if (this._configService.objectFromSnapshotLayout == "") { //variable For Normal use
    if (this._configService.objectFromSnapshotLayout == "" || this._configCustomService.layoutSubmitFlag == 0) {
      var x = this._configCustomService.widgetSaveObjectCustom[0].snapshotType;
      let layoutDetails = [];

      for (let i = 0; i < x.length; i++) {
        if (x[i].snapshotType_name === this._configCustomService.selectedSnapshotType.name) {
          for (let j = 0; j < x[i].section.length; j++) {
            if (x[i].section[j].section_name === this._configCustomService.selectedSection) {
              for (let k = 0; k < x[i].section[j].subsection.length; k++) {
                if (x[i].section[j].subsection[k].subsection_name ===
                  ((this._configCustomService.selectedSubsection == undefined || this._configCustomService.selectedSubsection == "") ? "NA" : this._configCustomService.selectedSubsection)) {
                  layoutDetails = x[i].section[j].subsection[k].page_details;
                }
              }
            }
          }
        }
      }

      this._configCustomService.dataFromPageDetail = layoutDetails; //variable used only while binding back
    }

  }
  getCallToEnablePreview(data: any) {
    //binding get data
    // var y=[];
    // y.push(data);
    if (this._configService.objectFromSnapshotLayout == "") { //variable For Normal use
      var x = data[0]?.snapshotType;
      let layoutDetails = [];
      let count = 0;
      for (let i = 0; i < x?.length; i++) {
        if (x[i].snapshotType_name === this._configCustomService.selectedSnapshotType.name) {
          for (let j = 0; j < x[i].section.length; j++) {
            if (x[i].section[j].section_name === this._configCustomService.selectedSection) {
              for (let k = 0; k < x[i].section[j].subsection.length; k++) {
                if (x[i].section[j].subsection[k].subsection_name ===
                  ((this._configCustomService.selectedSubsection == undefined || this._configCustomService.selectedSubsection == "") ? "NA" : this._configCustomService.selectedSubsection)) {
                  layoutDetails = x[i].section[j].subsection[k].page_details;
                  for (let g = 0; g < x[i].section[j].subsection[k].widget_detail.length; g++) {
                    if (x[i].section[j].subsection[k].widget_detail[g].previewChartPostion != 0) {
                      count++;
                    }
                  }
                }
              }
            }
          }
        }
      }


      if (this.widgetList.length == 0) {
        this.showPreview = false;
      }
      else {
        //adding two extra condition 
        if ((count > 0 || layoutDetails.length > 0) && (!this._configCustomService.recievedStatusDataOnBackButtonClick?.fromBack || this._configCustomService.backFromPreview == 1 || this._configCustomService.disablePreviewOnCustomizationSave == 0)) {
          this.showPreview = true;
        }
        else {
          this.showPreview = false;

        }
      }
      this.cdRef.detectChanges();
    }
  }
  collapseLayout(data: any) {
    this.layoutPopup = false;
  }
  EnablingDisablingPreview(data: any) {
    this.showPreview = false;//Making preview disable on layout submit as layout changed.
    // this.showPreview = data.bool;  //commented here
    // this.objectFromLayout=data.layoutData;
    this._configService.objectFromSnapshotLayout = data.layoutData;
    // this.datatoPreview=data.layoutData;
    this.layoutPopup = false;
    //Adding API CALL for storing the Layout Details
    let x = JSON.parse(data.layoutData);
    let arr = [];
    for (let i = 0; i < x.length; i++) {
      if (x[i].selectedLayout != null) {
        arr.push({
          key: x[i].page,
          value: x[i].selectedLayout
        })
      }
    }
    let objToSendForLayout = {
      ClientName: this._configService.clientName,
      SnapshotName: this.clientDetails.clientDetails.study,
      SnapshotTypeName: this._configCustomService.selectedSnapshotType.name,
      SectionName: this._configCustomService.selectedSection,
      SubsectionName: (this._configCustomService.selectedSubsection == undefined || this._configCustomService.selectedSubsection == "") ? "NA" : this._configCustomService.selectedSubsection,
      PageDetails: arr
    };
    this._configCustomService.saveCustomSnapshotLayout(objToSendForLayout).subscribe((data: any) => {

    })


  }
  EnablePreviewOnAdd(bool: boolean) {
    // this.showPreview = bool; //Commented here
  }


  duplicateWidgetAdded(status: any) {
    if (status) {
      this.showPreview = false;//Disabling preview button on change of no.
      this.updateChartSelectedNumber();
      this.cdRef.detectChanges();
    }
  }
  subsectionobj: any; sectionobj: any;
  deletesubsectionConfirmation(subsectionobj: any) {
    this.showDeletePopup = true;
    this.isDeleteSubsection = true;
    this.isDeleteSection = false;
    this.subsectionobj = subsectionobj;
    this.deletemessage = "Note : Deleting Subsection will delete all customizations in the selected Subsections."
  }

  deleteSectionConfirmation(sectionObj: any) {
    this.showDeletePopup = true;
    this.isDeleteSubsection = false;
    this.isDeleteSection = true;
    this.sectionobj = sectionObj;
    this.deletemessage = "Note : Deleting Section will delete all customizations in  the selected Sections and respective subsections."

  }


  receivedDeleteConfirmation(data: any) {
    this.showDeletePopup = false;
    this.deletemessage = "";
    if (data == 'yes') {
      if (this.isDeleteSubsection)
        this.deleteSubsection(this.subsectionobj)
      if (this.isDeleteSection)
        this.deleteSection(this.sectionobj);
    }
  }

}


